import { gosApi as api } from "src/datahandling/redux/api/rtkQueryCodeGen/gosApi/gosApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiApplications: build.query<
      GetApiApplicationsApiResponse,
      GetApiApplicationsApiArg
    >({
      query: () => ({ url: `/api/Applications` }),
      extraOptions: {},
    }),
    postApiApplications: build.mutation<
      PostApiApplicationsApiResponse,
      PostApiApplicationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Applications`,
        method: "POST",
        body: queryArg.saveApplicationRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiApplications: build.mutation<
      DeleteApiApplicationsApiResponse,
      DeleteApiApplicationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Applications`,
        method: "DELETE",
        params: {
          ids: queryArg.ids,
        },
      }),
      extraOptions: {},
    }),
    getApiApplicationsId: build.query<
      GetApiApplicationsIdApiResponse,
      GetApiApplicationsIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/Applications/${queryArg.id}` }),
      extraOptions: {},
    }),
    putApiApplicationsId: build.mutation<
      PutApiApplicationsIdApiResponse,
      PutApiApplicationsIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Applications/${queryArg.id}`,
        method: "PUT",
        body: queryArg.saveApplicationRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiApplicationsIdVersions: build.query<
      GetApiApplicationsIdVersionsApiResponse,
      GetApiApplicationsIdVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Applications/${queryArg.id}/Versions`,
      }),
      extraOptions: {},
    }),
    putApiApplicationsIdVersions: build.mutation<
      PutApiApplicationsIdVersionsApiResponse,
      PutApiApplicationsIdVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Applications/${queryArg.id}/Versions`,
        method: "PUT",
        body: queryArg.saveApplicationVersionRequestWeb,
      }),
      extraOptions: {},
    }),
    postApiV1Versions: build.mutation<
      PostApiV1VersionsApiResponse,
      PostApiV1VersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/Versions`,
        method: "POST",
        body: queryArg.applicationVersionRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiV2BargeHistories: build.query<
      GetApiV2BargeHistoriesApiResponse,
      GetApiV2BargeHistoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/BargeHistories`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2BargeHistoriesCount: build.query<
      GetApiV2BargeHistoriesCountApiResponse,
      GetApiV2BargeHistoriesCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/BargeHistories/$count`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2BargeModels: build.query<
      GetApiV2BargeModelsApiResponse,
      GetApiV2BargeModelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/BargeModels`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2BargeModelsCount: build.query<
      GetApiV2BargeModelsCountApiResponse,
      GetApiV2BargeModelsCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/BargeModels/$count`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2Barges: build.query<
      GetApiV2BargesApiResponse,
      GetApiV2BargesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Barges`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2BargesCount: build.query<
      GetApiV2BargesCountApiResponse,
      GetApiV2BargesCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Barges/$count`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2BargesKey: build.query<
      GetApiV2BargesKeyApiResponse,
      GetApiV2BargesKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Barges/${queryArg.key}`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    postApiV2Barges: build.mutation<
      PostApiV2BargesApiResponse,
      PostApiV2BargesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/barges`,
        method: "POST",
        body: queryArg.createBargeRequestWeb,
      }),
      extraOptions: {},
    }),
    putApiV2BargesKey: build.mutation<
      PutApiV2BargesKeyApiResponse,
      PutApiV2BargesKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/barges/${queryArg.key}`,
        method: "PUT",
        body: queryArg.updateBargeRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiV2BargesAvailable: build.query<
      GetApiV2BargesAvailableApiResponse,
      GetApiV2BargesAvailableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/barges/available`,
        params: {
          companyId: queryArg.companyId,
          name: queryArg.name,
        },
      }),
      extraOptions: {},
    }),
    getApiV2Companies: build.query<
      GetApiV2CompaniesApiResponse,
      GetApiV2CompaniesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Companies`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2CompaniesCount: build.query<
      GetApiV2CompaniesCountApiResponse,
      GetApiV2CompaniesCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Companies/$count`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2CompaniesKey: build.query<
      GetApiV2CompaniesKeyApiResponse,
      GetApiV2CompaniesKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Companies/${queryArg.key}`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiCompanies: build.query<
      GetApiCompaniesApiResponse,
      GetApiCompaniesApiArg
    >({
      query: () => ({ url: `/api/Companies` }),
      extraOptions: {},
    }),
    postApiCompanies: build.mutation<
      PostApiCompaniesApiResponse,
      PostApiCompaniesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies`,
        method: "POST",
        body: queryArg.createCompanyRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiCompaniesEntitiesSimple: build.query<
      GetApiCompaniesEntitiesSimpleApiResponse,
      GetApiCompaniesEntitiesSimpleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/entities/simple`,
        params: {
          companyId: queryArg.companyId,
        },
      }),
      extraOptions: {},
    }),
    getApiCompaniesEntitiesArea: build.query<
      GetApiCompaniesEntitiesAreaApiResponse,
      GetApiCompaniesEntitiesAreaApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/entities/${queryArg.area}`,
        params: {
          level: queryArg.level,
          includeDeleted: queryArg.includeDeleted,
        },
      }),
      extraOptions: {},
    }),
    getApiCompaniesSites: build.query<
      GetApiCompaniesSitesApiResponse,
      GetApiCompaniesSitesApiArg
    >({
      query: () => ({ url: `/api/Companies/Sites` }),
      extraOptions: {},
    }),
    getApiCompaniesId: build.query<
      GetApiCompaniesIdApiResponse,
      GetApiCompaniesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/${queryArg.id}`,
        params: {
          include: queryArg.include,
          includeDeleted: queryArg.includeDeleted,
        },
      }),
      extraOptions: {},
    }),
    putApiCompaniesId: build.mutation<
      PutApiCompaniesIdApiResponse,
      PutApiCompaniesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/${queryArg.id}`,
        method: "PUT",
        body: queryArg.updateCompanyRequestWeb,
      }),
      extraOptions: {},
    }),
    patchApiCompaniesId: build.mutation<
      PatchApiCompaniesIdApiResponse,
      PatchApiCompaniesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchCompanyRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiCompaniesId: build.mutation<
      DeleteApiCompaniesIdApiResponse,
      DeleteApiCompaniesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/${queryArg.id}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiCompaniesSelf: build.query<
      GetApiCompaniesSelfApiResponse,
      GetApiCompaniesSelfApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/Self`,
        params: {
          $include: queryArg.$include,
        },
      }),
      extraOptions: {},
    }),
    getApiCompaniesCompanyIdHierarchy: build.query<
      GetApiCompaniesCompanyIdHierarchyApiResponse,
      GetApiCompaniesCompanyIdHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/${queryArg.companyId}/hierarchy`,
        params: {
          $include: queryArg.$include,
        },
      }),
      extraOptions: {},
    }),
    getApiCompaniesCompanyIdSma: build.query<
      GetApiCompaniesCompanyIdSmaApiResponse,
      GetApiCompaniesCompanyIdSmaApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Companies/${queryArg.companyId}/sma`,
      }),
      extraOptions: {},
    }),
    getApiV2FeedCompanies: build.query<
      GetApiV2FeedCompaniesApiResponse,
      GetApiV2FeedCompaniesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/FeedCompanies`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2FeedCompaniesCount: build.query<
      GetApiV2FeedCompaniesCountApiResponse,
      GetApiV2FeedCompaniesCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/FeedCompanies/$count`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getFeedsId: build.query<GetFeedsIdApiResponse, GetFeedsIdApiArg>({
      query: (queryArg) => ({ url: `/feeds/${queryArg.id}` }),
      extraOptions: {},
    }),
    patchFeedsId: build.mutation<PatchFeedsIdApiResponse, PatchFeedsIdApiArg>({
      query: (queryArg) => ({
        url: `/feeds/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchFeedForCompanyRequestWeb,
      }),
      extraOptions: {},
    }),
    postFeeds: build.mutation<PostFeedsApiResponse, PostFeedsApiArg>({
      query: (queryArg) => ({
        url: `/feeds`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    getFeeds: build.query<GetFeedsApiResponse, GetFeedsApiArg>({
      query: (queryArg) => ({
        url: `/feeds`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    postFeedsIdDelete: build.mutation<
      PostFeedsIdDeleteApiResponse,
      PostFeedsIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/feeds/${queryArg.id}/delete`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    postFeedsIdDeleteHard: build.mutation<
      PostFeedsIdDeleteHardApiResponse,
      PostFeedsIdDeleteHardApiArg
    >({
      query: (queryArg) => ({
        url: `/feeds/${queryArg.id}/delete/hard`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    postFeedsIdUndelete: build.mutation<
      PostFeedsIdUndeleteApiResponse,
      PostFeedsIdUndeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/feeds/${queryArg.id}/undelete`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    getApiCompaniesCompanyIdFeeds: build.query<
      GetApiCompaniesCompanyIdFeedsApiResponse,
      GetApiCompaniesCompanyIdFeedsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/companies/${queryArg.companyId}/feeds`,
        params: {
          includeDeleted: queryArg.includeDeleted,
        },
      }),
      extraOptions: {},
    }),
    patchApiCompaniesCompanyIdFeedsFeedId: build.mutation<
      PatchApiCompaniesCompanyIdFeedsFeedIdApiResponse,
      PatchApiCompaniesCompanyIdFeedsFeedIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/companies/${queryArg.companyId}/feeds/${queryArg.feedId}`,
        method: "PATCH",
        body: queryArg.patchFeedForCompanyRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiFeedsId: build.mutation<
      DeleteApiFeedsIdApiResponse,
      DeleteApiFeedsIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Feeds/${queryArg.id}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiFeedsId: build.query<GetApiFeedsIdApiResponse, GetApiFeedsIdApiArg>({
      query: (queryArg) => ({ url: `/api/Feeds/${queryArg.id}` }),
      extraOptions: {},
    }),
    patchApiFeedsId: build.mutation<
      PatchApiFeedsIdApiResponse,
      PatchApiFeedsIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Feeds/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    getApiFeeds: build.query<GetApiFeedsApiResponse, GetApiFeedsApiArg>({
      query: () => ({ url: `/api/Feeds` }),
      extraOptions: {},
    }),
    postApiFeeds: build.mutation<PostApiFeedsApiResponse, PostApiFeedsApiArg>({
      query: (queryArg) => ({
        url: `/api/Feeds`,
        method: "POST",
        body: queryArg.saveFeedRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiFeedsBycompanyCompanyId: build.query<
      GetApiFeedsBycompanyCompanyIdApiResponse,
      GetApiFeedsBycompanyCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Feeds/bycompany/${queryArg.companyId}`,
      }),
      extraOptions: {},
    }),
    getApiV2FeedsGetAllForSiteSiteIdNull: build.query<
      GetApiV2FeedsGetAllForSiteSiteIdNullApiResponse,
      GetApiV2FeedsGetAllForSiteSiteIdNullApiArg
    >({
      query: () => ({ url: `/api/v2/Feeds/GetAllForSite(SiteId=null)` }),
      extraOptions: {},
    }),
    getFeedSuppliersId: build.query<
      GetFeedSuppliersIdApiResponse,
      GetFeedSuppliersIdApiArg
    >({
      query: (queryArg) => ({ url: `/feed-suppliers/${queryArg.id}` }),
      extraOptions: {},
    }),
    patchFeedSuppliersId: build.mutation<
      PatchFeedSuppliersIdApiResponse,
      PatchFeedSuppliersIdApiArg
    >({
      query: (queryArg) => ({
        url: `/feed-suppliers/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchFeedSupplierRequestWeb,
      }),
      extraOptions: {},
    }),
    postFeedSuppliers: build.mutation<
      PostFeedSuppliersApiResponse,
      PostFeedSuppliersApiArg
    >({
      query: (queryArg) => ({
        url: `/feed-suppliers`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    getFeedSuppliers: build.query<
      GetFeedSuppliersApiResponse,
      GetFeedSuppliersApiArg
    >({
      query: (queryArg) => ({
        url: `/feed-suppliers`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    postFeedSuppliersIdDelete: build.mutation<
      PostFeedSuppliersIdDeleteApiResponse,
      PostFeedSuppliersIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/feed-suppliers/${queryArg.id}/delete`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    postFeedSuppliersIdDeleteHard: build.mutation<
      PostFeedSuppliersIdDeleteHardApiResponse,
      PostFeedSuppliersIdDeleteHardApiArg
    >({
      query: (queryArg) => ({
        url: `/feed-suppliers/${queryArg.id}/delete/hard`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    postFeedSuppliersIdUndelete: build.mutation<
      PostFeedSuppliersIdUndeleteApiResponse,
      PostFeedSuppliersIdUndeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/feed-suppliers/${queryArg.id}/undelete`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    getApiV2FeedSuppliers: build.query<
      GetApiV2FeedSuppliersApiResponse,
      GetApiV2FeedSuppliersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/FeedSuppliers`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2FeedSuppliersCount: build.query<
      GetApiV2FeedSuppliersCountApiResponse,
      GetApiV2FeedSuppliersCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/FeedSuppliers/$count`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    postApiFeedSuppliers: build.mutation<
      PostApiFeedSuppliersApiResponse,
      PostApiFeedSuppliersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/FeedSuppliers`,
        method: "POST",
        body: queryArg.saveFeedSupplierRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiFeedSuppliers: build.query<
      GetApiFeedSuppliersApiResponse,
      GetApiFeedSuppliersApiArg
    >({
      query: () => ({ url: `/api/FeedSuppliers` }),
      extraOptions: {},
    }),
    patchApiFeedSuppliersId: build.mutation<
      PatchApiFeedSuppliersIdApiResponse,
      PatchApiFeedSuppliersIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/FeedSuppliers/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    getApiV2Groups: build.query<
      GetApiV2GroupsApiResponse,
      GetApiV2GroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Groups`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2GroupsCount: build.query<
      GetApiV2GroupsCountApiResponse,
      GetApiV2GroupsCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Groups/$count`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2GroupsGetGroupsByCompanyCompanyIdCompanyId: build.query<
      GetApiV2GroupsGetGroupsByCompanyCompanyIdCompanyIdApiResponse,
      GetApiV2GroupsGetGroupsByCompanyCompanyIdCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Groups/GetGroupsByCompany(companyId=${queryArg.companyId})`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2GroupsKey: build.query<
      GetApiV2GroupsKeyApiResponse,
      GetApiV2GroupsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Groups/${queryArg.key}`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2GroupsGetGroupsAndDescendants: build.query<
      GetApiV2GroupsGetGroupsAndDescendantsApiResponse,
      GetApiV2GroupsGetGroupsAndDescendantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Groups/GetGroupsAndDescendants`,
        params: {
          groupIds: queryArg.groupIds,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    postApiV2Groups: build.mutation<
      PostApiV2GroupsApiResponse,
      PostApiV2GroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/groups`,
        method: "POST",
        body: queryArg.createGroupRequestWeb,
      }),
      extraOptions: {},
    }),
    putApiV2GroupsKey: build.mutation<
      PutApiV2GroupsKeyApiResponse,
      PutApiV2GroupsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/groups/${queryArg.key}`,
        method: "PUT",
        body: queryArg.updateGroupRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiV2GroupsKey: build.mutation<
      DeleteApiV2GroupsKeyApiResponse,
      DeleteApiV2GroupsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/groups/${queryArg.key}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    postApiV2LevelsPostTree: build.mutation<
      PostApiV2LevelsPostTreeApiResponse,
      PostApiV2LevelsPostTreeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/levels/postTree`,
        method: "POST",
        body: queryArg.saveCompanyLevelRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiV2Levels: build.query<
      GetApiV2LevelsApiResponse,
      GetApiV2LevelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Levels`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2LevelsCount: build.query<
      GetApiV2LevelsCountApiResponse,
      GetApiV2LevelsCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Levels/$count`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2LevelsGetAllForCompanyCompanyIdCompanyId: build.query<
      GetApiV2LevelsGetAllForCompanyCompanyIdCompanyIdApiResponse,
      GetApiV2LevelsGetAllForCompanyCompanyIdCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Levels/GetAllForCompany(companyId=${queryArg.companyId})`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2LevelsKey: build.query<
      GetApiV2LevelsKeyApiResponse,
      GetApiV2LevelsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Levels/${queryArg.key}`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getCompanyPropertiesId: build.query<
      GetCompanyPropertiesIdApiResponse,
      GetCompanyPropertiesIdApiArg
    >({
      query: (queryArg) => ({ url: `/company-properties/${queryArg.id}` }),
      extraOptions: {},
    }),
    patchCompanyPropertiesId: build.mutation<
      PatchCompanyPropertiesIdApiResponse,
      PatchCompanyPropertiesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/company-properties/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchPropertyValueRequestWeb,
      }),
      extraOptions: {},
    }),
    getCompanyProperties: build.query<
      GetCompanyPropertiesApiResponse,
      GetCompanyPropertiesApiArg
    >({
      query: (queryArg) => ({
        url: `/company-properties`,
        params: {
          companyId: queryArg.companyId,
        },
      }),
      extraOptions: {},
    }),
    postCompanyProperties: build.mutation<
      PostCompanyPropertiesApiResponse,
      PostCompanyPropertiesApiArg
    >({
      query: (queryArg) => ({
        url: `/company-properties`,
        method: "POST",
        body: queryArg.createCompanyPropertyRequestWeb,
      }),
      extraOptions: {},
    }),
    postCompanyPropertiesIdDeleteHard: build.mutation<
      PostCompanyPropertiesIdDeleteHardApiResponse,
      PostCompanyPropertiesIdDeleteHardApiArg
    >({
      query: (queryArg) => ({
        url: `/company-properties/${queryArg.id}/delete/hard`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    getPropertiesId: build.query<
      GetPropertiesIdApiResponse,
      GetPropertiesIdApiArg
    >({
      query: (queryArg) => ({ url: `/properties/${queryArg.id}` }),
      extraOptions: {},
    }),
    patchPropertiesId: build.mutation<
      PatchPropertiesIdApiResponse,
      PatchPropertiesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/properties/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchPropertyRequestWeb,
      }),
      extraOptions: {},
    }),
    getProperties: build.query<GetPropertiesApiResponse, GetPropertiesApiArg>({
      query: () => ({ url: `/properties` }),
      extraOptions: {},
    }),
    postProperties: build.mutation<
      PostPropertiesApiResponse,
      PostPropertiesApiArg
    >({
      query: (queryArg) => ({
        url: `/properties`,
        method: "POST",
        body: queryArg.createPropertyRequestWeb,
      }),
      extraOptions: {},
    }),
    postPropertiesIdDeleteHard: build.mutation<
      PostPropertiesIdDeleteHardApiResponse,
      PostPropertiesIdDeleteHardApiArg
    >({
      query: (queryArg) => ({
        url: `/properties/${queryArg.id}/delete/hard`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    getSitePropertiesId: build.query<
      GetSitePropertiesIdApiResponse,
      GetSitePropertiesIdApiArg
    >({
      query: (queryArg) => ({ url: `/site-properties/${queryArg.id}` }),
      extraOptions: {},
    }),
    patchSitePropertiesId: build.mutation<
      PatchSitePropertiesIdApiResponse,
      PatchSitePropertiesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/site-properties/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchPropertyValueRequestWeb,
      }),
      extraOptions: {},
    }),
    getSiteProperties: build.query<
      GetSitePropertiesApiResponse,
      GetSitePropertiesApiArg
    >({
      query: (queryArg) => ({
        url: `/site-properties`,
        params: {
          siteId: queryArg.siteId,
        },
      }),
      extraOptions: {},
    }),
    postSiteProperties: build.mutation<
      PostSitePropertiesApiResponse,
      PostSitePropertiesApiArg
    >({
      query: (queryArg) => ({
        url: `/site-properties`,
        method: "POST",
        body: queryArg.createSitePropertyRequestWeb,
      }),
      extraOptions: {},
    }),
    postSitePropertiesIdDeleteHard: build.mutation<
      PostSitePropertiesIdDeleteHardApiResponse,
      PostSitePropertiesIdDeleteHardApiArg
    >({
      query: (queryArg) => ({
        url: `/site-properties/${queryArg.id}/delete/hard`,
        method: "POST",
      }),
      extraOptions: {},
    }),
    getPublicMetaCompany20230101: build.query<
      GetPublicMetaCompany20230101ApiResponse,
      GetPublicMetaCompany20230101ApiArg
    >({
      query: (queryArg) => ({
        url: `/public/meta/company/2023-01-01`,
        params: {
          $include: queryArg.$include,
        },
      }),
      extraOptions: {},
    }),
    getPublicMetaCompany20250101: build.query<
      GetPublicMetaCompany20250101ApiResponse,
      GetPublicMetaCompany20250101ApiArg
    >({
      query: (queryArg) => ({
        url: `/public/meta/company/2025-01-01`,
        params: {
          include: queryArg.include,
        },
      }),
      extraOptions: {},
    }),
    getPublicMetaSitesId20230101: build.query<
      GetPublicMetaSitesId20230101ApiResponse,
      GetPublicMetaSitesId20230101ApiArg
    >({
      query: (queryArg) => ({
        url: `/public/meta/sites/${queryArg.id}/2023-01-01`,
        params: {
          $include: queryArg.$include,
        },
      }),
      extraOptions: {},
    }),
    getPublicMetaSitesId20250101: build.query<
      GetPublicMetaSitesId20250101ApiResponse,
      GetPublicMetaSitesId20250101ApiArg
    >({
      query: (queryArg) => ({
        url: `/public/meta/sites/${queryArg.id}/2025-01-01`,
        params: {
          include: queryArg.include,
        },
      }),
      extraOptions: {},
    }),
    getApiV2Silos: build.query<GetApiV2SilosApiResponse, GetApiV2SilosApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/Silos`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          includeBargeSilo: queryArg.includeBargeSilo,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2SilosCount: build.query<
      GetApiV2SilosCountApiResponse,
      GetApiV2SilosCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Silos/$count`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          includeBargeSilo: queryArg.includeBargeSilo,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2SilosKey: build.query<
      GetApiV2SilosKeyApiResponse,
      GetApiV2SilosKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Silos/${queryArg.key}`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiSitesSiteIdSilos: build.query<
      GetApiSitesSiteIdSilosApiResponse,
      GetApiSitesSiteIdSilosApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/silos`,
        params: {
          includeDeleted: queryArg.includeDeleted,
        },
      }),
      extraOptions: {},
    }),
    patchApiSilosId: build.mutation<
      PatchApiSilosIdApiResponse,
      PatchApiSilosIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Silos/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchSiloRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiSilosId: build.mutation<
      DeleteApiSilosIdApiResponse,
      DeleteApiSilosIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Silos/${queryArg.id}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    postApiSilos: build.mutation<PostApiSilosApiResponse, PostApiSilosApiArg>({
      query: (queryArg) => ({
        url: `/api/Silos`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    getApiSitesSiteIdSilosAvailable: build.query<
      GetApiSitesSiteIdSilosAvailableApiResponse,
      GetApiSitesSiteIdSilosAvailableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/silos/available`,
        params: {
          siloName: queryArg.siloName,
          type: queryArg["type"],
        },
      }),
      extraOptions: {},
    }),
    getApiV2Sites: build.query<GetApiV2SitesApiResponse, GetApiV2SitesApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/Sites`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2SitesCount: build.query<
      GetApiV2SitesCountApiResponse,
      GetApiV2SitesCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Sites/$count`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2SitesKey: build.query<
      GetApiV2SitesKeyApiResponse,
      GetApiV2SitesKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Sites/${queryArg.key}`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiSites: build.query<GetApiSitesApiResponse, GetApiSitesApiArg>({
      query: () => ({ url: `/api/Sites` }),
      extraOptions: {},
    }),
    postApiSites: build.mutation<PostApiSitesApiResponse, PostApiSitesApiArg>({
      query: (queryArg) => ({
        url: `/api/Sites`,
        method: "POST",
        body: queryArg.createSiteRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiCompaniesCompanyIdSites: build.query<
      GetApiCompaniesCompanyIdSitesApiResponse,
      GetApiCompaniesCompanyIdSitesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/companies/${queryArg.companyId}/sites`,
        params: {
          changedAfter: queryArg.changedAfter,
          includeDeleted: queryArg.includeDeleted,
        },
      }),
      extraOptions: {},
    }),
    getApiSitesId: build.query<GetApiSitesIdApiResponse, GetApiSitesIdApiArg>({
      query: (queryArg) => ({
        url: `/api/Sites/${queryArg.id}`,
        params: {
          include: queryArg.include,
        },
      }),
      extraOptions: {},
    }),
    putApiSitesId: build.mutation<
      PutApiSitesIdApiResponse,
      PutApiSitesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Sites/${queryArg.id}`,
        method: "PUT",
        body: queryArg.updateSiteRequestWeb,
      }),
      extraOptions: {},
    }),
    patchApiSitesId: build.mutation<
      PatchApiSitesIdApiResponse,
      PatchApiSitesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Sites/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.patchSiteRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiSitesId: build.mutation<
      DeleteApiSitesIdApiResponse,
      DeleteApiSitesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Sites/${queryArg.id}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiSitesSelfId: build.query<
      GetApiSitesSelfIdApiResponse,
      GetApiSitesSelfIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Sites/self/${queryArg.id}`,
        params: {
          $include: queryArg.$include,
        },
      }),
      extraOptions: {},
    }),
    getApiStationLicenseBillingGroupsSiteIdApplicationId: build.query<
      GetApiStationLicenseBillingGroupsSiteIdApplicationIdApiResponse,
      GetApiStationLicenseBillingGroupsSiteIdApplicationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenseBillingGroups/${queryArg.siteId}/${queryArg.applicationId}`,
      }),
      extraOptions: {},
    }),
    putApiStationLicenseBillingGroupsSiteIdApplicationId: build.mutation<
      PutApiStationLicenseBillingGroupsSiteIdApplicationIdApiResponse,
      PutApiStationLicenseBillingGroupsSiteIdApplicationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenseBillingGroups/${queryArg.siteId}/${queryArg.applicationId}`,
        method: "PUT",
        body: queryArg.putStationLicenseBillingGroupRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiV2StationLicenses: build.query<
      GetApiV2StationLicensesApiResponse,
      GetApiV2StationLicensesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/StationLicenses`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2StationLicensesCount: build.query<
      GetApiV2StationLicensesCountApiResponse,
      GetApiV2StationLicensesCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/StationLicenses/$count`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2StationLicensesKey: build.query<
      GetApiV2StationLicensesKeyApiResponse,
      GetApiV2StationLicensesKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/StationLicenses/${queryArg.key}`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2StationLicensesGetAllGroupedBySiteAndProduct: build.query<
      GetApiV2StationLicensesGetAllGroupedBySiteAndProductApiResponse,
      GetApiV2StationLicensesGetAllGroupedBySiteAndProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/StationLicenses/GetAllGroupedBySiteAndProduct`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2StationLicensesGetAllGroupedByApplicationAndSwVersion: build.query<
      GetApiV2StationLicensesGetAllGroupedByApplicationAndSwVersionApiResponse,
      GetApiV2StationLicensesGetAllGroupedByApplicationAndSwVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/StationLicenses/GetAllGroupedByApplicationAndSwVersion`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiStationLicensesAuth: build.query<
      GetApiStationLicensesAuthApiResponse,
      GetApiStationLicensesAuthApiArg
    >({
      query: () => ({ url: `/api/StationLicenses/auth` }),
      extraOptions: {},
    }),
    postApiStationLicensesAuth: build.mutation<
      PostApiStationLicensesAuthApiResponse,
      PostApiStationLicensesAuthApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/auth`,
        method: "POST",
        body: queryArg.authorizeStationLicenseRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiStationLicenses: build.query<
      GetApiStationLicensesApiResponse,
      GetApiStationLicensesApiArg
    >({
      query: () => ({ url: `/api/StationLicenses` }),
      extraOptions: {},
    }),
    putApiStationLicenses: build.mutation<
      PutApiStationLicensesApiResponse,
      PutApiStationLicensesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses`,
        method: "PUT",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    deleteApiStationLicenses: build.mutation<
      DeleteApiStationLicensesApiResponse,
      DeleteApiStationLicensesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses`,
        method: "DELETE",
        params: {
          ids: queryArg.ids,
        },
      }),
      extraOptions: {},
    }),
    getApiStationLicensesCompanyCompanyId: build.query<
      GetApiStationLicensesCompanyCompanyIdApiResponse,
      GetApiStationLicensesCompanyCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/company/${queryArg.companyId}`,
      }),
      extraOptions: {},
    }),
    getApiStationLicensesId: build.query<
      GetApiStationLicensesIdApiResponse,
      GetApiStationLicensesIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/StationLicenses/${queryArg.id}` }),
      extraOptions: {},
    }),
    putApiStationLicensesId: build.mutation<
      PutApiStationLicensesIdApiResponse,
      PutApiStationLicensesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/${queryArg.id}`,
        method: "PUT",
        body: queryArg.updateStationLicenseRequestWeb,
      }),
      extraOptions: {},
    }),
    postApiStationLicensesStatus: build.mutation<
      PostApiStationLicensesStatusApiResponse,
      PostApiStationLicensesStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/status`,
        method: "POST",
        body: queryArg.statusStationLicenseRequestWeb,
      }),
      extraOptions: {},
    }),
    postApiStationLicensesActivatelicense: build.mutation<
      PostApiStationLicensesActivatelicenseApiResponse,
      PostApiStationLicensesActivatelicenseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/activatelicense`,
        method: "POST",
        body: queryArg.activateStationLicenseRequestWeb,
      }),
      extraOptions: {},
    }),
    postApiStationLicensesCreateactivationcode: build.mutation<
      PostApiStationLicensesCreateactivationcodeApiResponse,
      PostApiStationLicensesCreateactivationcodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/createactivationcode`,
        method: "POST",
        body: queryArg.createStationLicenseActivationCodeRequestWeb,
      }),
      extraOptions: {},
    }),
    postApiStationLicensesCreateactivationcodes: build.mutation<
      PostApiStationLicensesCreateactivationcodesApiResponse,
      PostApiStationLicensesCreateactivationcodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/createactivationcodes`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    postApiStationLicensesCreatelicensekey: build.mutation<
      PostApiStationLicensesCreatelicensekeyApiResponse,
      PostApiStationLicensesCreatelicensekeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/createlicensekey`,
        method: "POST",
        body: queryArg.createStationLicenseKeyRequestWeb,
      }),
      extraOptions: {},
    }),
    postApiStationLicensesCreatelicensekeys: build.mutation<
      PostApiStationLicensesCreatelicensekeysApiResponse,
      PostApiStationLicensesCreatelicensekeysApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/createlicensekeys`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    putApiStationLicensesIdVersion: build.mutation<
      PutApiStationLicensesIdVersionApiResponse,
      PutApiStationLicensesIdVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/${queryArg.id}/version`,
        method: "PUT",
        body: queryArg.updateStationLicenseVersionRequestWeb,
      }),
      extraOptions: {},
    }),
    putApiStationLicensesIdCategories: build.mutation<
      PutApiStationLicensesIdCategoriesApiResponse,
      PutApiStationLicensesIdCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/StationLicenses/${queryArg.id}/categories`,
        method: "PUT",
        body: queryArg.updateStationLicenseCategoryWeb,
      }),
      extraOptions: {},
    }),
    postApiV2Tenants: build.mutation<
      PostApiV2TenantsApiResponse,
      PostApiV2TenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/tenants`,
        method: "POST",
        body: queryArg.updateTenantRequestWeb,
      }),
      extraOptions: {},
    }),
    getApiV2Tenants: build.query<
      GetApiV2TenantsApiResponse,
      GetApiV2TenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Tenants`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2TenantsCount: build.query<
      GetApiV2TenantsCountApiResponse,
      GetApiV2TenantsCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Tenants/$count`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2TenantsKey: build.query<
      GetApiV2TenantsKeyApiResponse,
      GetApiV2TenantsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Tenants/${queryArg.key}`,
        params: {
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    putApiV2TenantsKey: build.mutation<
      PutApiV2TenantsKeyApiResponse,
      PutApiV2TenantsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/tenants/${queryArg.key}`,
        method: "PUT",
        body: queryArg.updateTenantRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiV2TenantsKey: build.mutation<
      DeleteApiV2TenantsKeyApiResponse,
      DeleteApiV2TenantsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/tenants/${queryArg.key}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiSitesSiteIdUnitgroups: build.query<
      GetApiSitesSiteIdUnitgroupsApiResponse,
      GetApiSitesSiteIdUnitgroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/unitgroups`,
        params: {
          includeUnit: queryArg.includeUnit,
        },
      }),
      extraOptions: {},
    }),
    postApiSitesSiteIdUnitgroups: build.mutation<
      PostApiSitesSiteIdUnitgroupsApiResponse,
      PostApiSitesSiteIdUnitgroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/unitgroups`,
        method: "POST",
        body: queryArg.createUnitGroupRequestWeb,
      }),
      extraOptions: {},
    }),
    putApiSitesSiteIdUnitgroupsId: build.mutation<
      PutApiSitesSiteIdUnitgroupsIdApiResponse,
      PutApiSitesSiteIdUnitgroupsIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/unitgroups/${queryArg.id}`,
        method: "PUT",
        body: queryArg.updateUnitGroupRequestWeb,
      }),
      extraOptions: {},
    }),
    deleteApiSitesSiteIdUnitgroupsId: build.mutation<
      DeleteApiSitesSiteIdUnitgroupsIdApiResponse,
      DeleteApiSitesSiteIdUnitgroupsIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/unitgroups/${queryArg.id}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    postApiSitesSiteIdUnitgroupsAll: build.mutation<
      PostApiSitesSiteIdUnitgroupsAllApiResponse,
      PostApiSitesSiteIdUnitgroupsAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/unitgroups/all`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    getApiV2Units: build.query<GetApiV2UnitsApiResponse, GetApiV2UnitsApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/Units`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2UnitsCount: build.query<
      GetApiV2UnitsCountApiResponse,
      GetApiV2UnitsCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Units/$count`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiV2UnitsKey: build.query<
      GetApiV2UnitsKeyApiResponse,
      GetApiV2UnitsKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/Units/${queryArg.key}`,
        params: {
          includeDeleted: queryArg.includeDeleted,
          $top: queryArg.$top,
          $apply: queryArg.$apply,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $select: queryArg.$select,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
      extraOptions: {},
    }),
    getApiSitesSiteIdUnits: build.query<
      GetApiSitesSiteIdUnitsApiResponse,
      GetApiSitesSiteIdUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units`,
        params: {
          changedAfter: queryArg.changedAfter,
          includeDeleted: queryArg.includeDeleted,
        },
      }),
      extraOptions: {},
    }),
    postApiSitesSiteIdUnits: build.mutation<
      PostApiSitesSiteIdUnitsApiResponse,
      PostApiSitesSiteIdUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    getApiSitesSiteIdUnitsUnitId: build.query<
      GetApiSitesSiteIdUnitsUnitIdApiResponse,
      GetApiSitesSiteIdUnitsUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units/${queryArg.unitId}`,
      }),
      extraOptions: {},
    }),
    putApiSitesSiteIdUnitsUnitId: build.mutation<
      PutApiSitesSiteIdUnitsUnitIdApiResponse,
      PutApiSitesSiteIdUnitsUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units/${queryArg.unitId}`,
        method: "PUT",
        body: queryArg.updateUnitRequestWeb,
      }),
      extraOptions: {},
    }),
    patchApiSitesSiteIdUnitsUnitId: build.mutation<
      PatchApiSitesSiteIdUnitsUnitIdApiResponse,
      PatchApiSitesSiteIdUnitsUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units/${queryArg.unitId}`,
        method: "PATCH",
        body: queryArg.patchUnitRequestWeb,
      }),
      extraOptions: {},
    }),
    postApiSitesSiteIdUnitsAll: build.mutation<
      PostApiSitesSiteIdUnitsAllApiResponse,
      PostApiSitesSiteIdUnitsAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units/all`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    deleteApiSitesSiteIdUnitsId: build.mutation<
      DeleteApiSitesSiteIdUnitsIdApiResponse,
      DeleteApiSitesSiteIdUnitsIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units/${queryArg.id}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiUnitsShapes: build.query<
      GetApiUnitsShapesApiResponse,
      GetApiUnitsShapesApiArg
    >({
      query: () => ({ url: `/api/units/shapes` }),
      extraOptions: {},
    }),
    getApiUnitsModels: build.query<
      GetApiUnitsModelsApiResponse,
      GetApiUnitsModelsApiArg
    >({
      query: () => ({ url: `/api/units/models` }),
      extraOptions: {},
    }),
    getApiSitesSiteIdUnitsAvailable: build.query<
      GetApiSitesSiteIdUnitsAvailableApiResponse,
      GetApiSitesSiteIdUnitsAvailableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units/available`,
        params: {
          unitName: queryArg.unitName,
          type: queryArg["type"],
        },
      }),
      extraOptions: {},
    }),
    getApiSitesSiteIdUnitsUnitIdHistory: build.query<
      GetApiSitesSiteIdUnitsUnitIdHistoryApiResponse,
      GetApiSitesSiteIdUnitsUnitIdHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sites/${queryArg.siteId}/units/${queryArg.unitId}/history`,
      }),
      extraOptions: {},
    }),
    getApiUserAccessSites: build.query<
      GetApiUserAccessSitesApiResponse,
      GetApiUserAccessSitesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/UserAccess/sites`,
        params: {
          siteIds: queryArg.siteIds,
        },
      }),
      extraOptions: {},
    }),
    getApiUserAccessSitesbygroup: build.query<
      GetApiUserAccessSitesbygroupApiResponse,
      GetApiUserAccessSitesbygroupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/UserAccess/sitesbygroup`,
        params: {
          groupIds: queryArg.groupIds,
        },
      }),
      extraOptions: {},
    }),

  }),
  overrideExisting: false,
});
export { injectedRtkApi as gosApi };
export type GetApiApplicationsApiResponse =
  /** status 200 OK */ ApplicationWeb[];
export type GetApiApplicationsApiArg = void;
export type PostApiApplicationsApiResponse =
  /** status 201 Created */ ApplicationWeb;
export type PostApiApplicationsApiArg = {
  saveApplicationRequestWeb: SaveApplicationRequestWeb;
};
export type DeleteApiApplicationsApiResponse = unknown;
export type DeleteApiApplicationsApiArg = {
  ids?: string[];
};
export type GetApiApplicationsIdApiResponse =
  /** status 200 OK */ ApplicationWeb;
export type GetApiApplicationsIdApiArg = {
  id: string;
};
export type PutApiApplicationsIdApiResponse = unknown;
export type PutApiApplicationsIdApiArg = {
  id: string;
  saveApplicationRequestWeb: SaveApplicationRequestWeb;
};
export type GetApiApplicationsIdVersionsApiResponse =
  /** status 200 OK */ ApplicationVersionWeb[];
export type GetApiApplicationsIdVersionsApiArg = {
  id: string;
};
export type PutApiApplicationsIdVersionsApiResponse =
  /** status 200 OK */ ApplicationVersionWeb;
export type PutApiApplicationsIdVersionsApiArg = {
  id: string;
  saveApplicationVersionRequestWeb: SaveApplicationVersionRequestWeb;
};
export type PostApiV1VersionsApiResponse =
  /** status 200 OK */ ApplicationVersionWeb;
export type PostApiV1VersionsApiArg = {
  applicationVersionRequestWeb: ApplicationVersionRequestWeb;
};
export type GetApiV2BargeHistoriesApiResponse =
  /** status 200 OK */ BargeHistoryIEnumerableODataValue;
export type GetApiV2BargeHistoriesApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2BargeHistoriesCountApiResponse =
  /** status 200 OK */ BargeHistoryIEnumerableODataValue;
export type GetApiV2BargeHistoriesCountApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2BargeModelsApiResponse =
  /** status 200 OK */ BargeModelIEnumerableODataValue;
export type GetApiV2BargeModelsApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2BargeModelsCountApiResponse =
  /** status 200 OK */ BargeModelIEnumerableODataValue;
export type GetApiV2BargeModelsCountApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2BargesApiResponse =
  /** status 200 OK */ BargeIEnumerableODataValue;
export type GetApiV2BargesApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2BargesCountApiResponse =
  /** status 200 OK */ BargeIEnumerableODataValue;
export type GetApiV2BargesCountApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2BargesKeyApiResponse = /** status 200 OK */ BargeRead;
export type GetApiV2BargesKeyApiArg = {
  key: number;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type PostApiV2BargesApiResponse = /** status 200 OK */ BargeRead;
export type PostApiV2BargesApiArg = {
  createBargeRequestWeb: CreateBargeRequestWeb;
};
export type PutApiV2BargesKeyApiResponse = /** status 200 OK */ BargeRead;
export type PutApiV2BargesKeyApiArg = {
  key: number;
  updateBargeRequestWeb: UpdateBargeRequestWeb;
};
export type GetApiV2BargesAvailableApiResponse = /** status 200 OK */ boolean;
export type GetApiV2BargesAvailableApiArg = {
  companyId: string;
  name: string;
};
export type GetApiV2CompaniesApiResponse =
  /** status 200 OK */ CompanyIEnumerableODataValueRead;
export type GetApiV2CompaniesApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2CompaniesCountApiResponse =
  /** status 200 OK */ CompanyIEnumerableODataValueRead;
export type GetApiV2CompaniesCountApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2CompaniesKeyApiResponse = /** status 200 OK */ CompanyRead;
export type GetApiV2CompaniesKeyApiArg = {
  key: string;
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiCompaniesApiResponse = /** status 200 OK */ CompanyRead[];
export type GetApiCompaniesApiArg = void;
export type PostApiCompaniesApiResponse = /** status 201 Created */ CompanyRead;
export type PostApiCompaniesApiArg = {
  createCompanyRequestWeb: CreateCompanyRequestWeb;
};
export type GetApiCompaniesEntitiesSimpleApiResponse =
  /** status 200 OK */ SimpleCompanyWeb[];
export type GetApiCompaniesEntitiesSimpleApiArg = {
  companyId?: string;
};
export type GetApiCompaniesEntitiesAreaApiResponse =
  /** status 200 OK */ CompanyWeb[];
export type GetApiCompaniesEntitiesAreaApiArg = {
  area: string;
  level?: string;
  includeDeleted?: boolean;
};
export type GetApiCompaniesSitesApiResponse =
  /** status 200 OK */ CompanyRead[];
export type GetApiCompaniesSitesApiArg = void;
export type GetApiCompaniesIdApiResponse = /** status 200 OK */ CompanyWeb;
export type GetApiCompaniesIdApiArg = {
  id: string;
  include?: CompanyIncludeQueryWeb[];
  includeDeleted?: boolean;
};
export type PutApiCompaniesIdApiResponse = unknown;
export type PutApiCompaniesIdApiArg = {
  id: string;
  updateCompanyRequestWeb: UpdateCompanyRequestWeb;
};
export type PatchApiCompaniesIdApiResponse = /** status 200 OK */ CompanyWeb;
export type PatchApiCompaniesIdApiArg = {
  id: string;
  patchCompanyRequestWeb: PatchCompanyRequestWeb;
};
export type DeleteApiCompaniesIdApiResponse = unknown;
export type DeleteApiCompaniesIdApiArg = {
  id: string;
};
export type GetApiCompaniesSelfApiResponse =
  /** status 200 OK */ CompanySiteBriefInfoWeb;
export type GetApiCompaniesSelfApiArg = {
  $include?: string;
};
export type GetApiCompaniesCompanyIdHierarchyApiResponse =
  /** status 200 OK */ CompanyHierarchyWeb;
export type GetApiCompaniesCompanyIdHierarchyApiArg = {
  companyId: string;
  $include?: string;
};
export type GetApiCompaniesCompanyIdSmaApiResponse =
  /** status 200 OK */ CompanyWebSma[];
export type GetApiCompaniesCompanyIdSmaApiArg = {
  companyId: string;
};
export type GetApiV2FeedCompaniesApiResponse =
  /** status 200 OK */ FeedCompanyIEnumerableODataValue;
export type GetApiV2FeedCompaniesApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2FeedCompaniesCountApiResponse =
  /** status 200 OK */ FeedCompanyIEnumerableODataValue;
export type GetApiV2FeedCompaniesCountApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetFeedsIdApiResponse = /** status 200 OK */ FeedForCompanyWeb;
export type GetFeedsIdApiArg = {
  id: number;
};
export type PatchFeedsIdApiResponse = /** status 200 OK */ FeedForCompanyWeb;
export type PatchFeedsIdApiArg = {
  id: number;
  patchFeedForCompanyRequestWeb: PatchFeedForCompanyRequestWeb;
};
export type PostFeedsApiResponse = /** status 200 OK */ FeedForCompanyWeb[];
export type PostFeedsApiArg = {
  body: CreateFeedForCompanyRequestWeb[];
};
export type GetFeedsApiResponse =
  /** status 200 OK */ FeedForCompanyWebIEnumerableODataValue;
export type GetFeedsApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type PostFeedsIdDeleteApiResponse = unknown;
export type PostFeedsIdDeleteApiArg = {
  id: number;
};
export type PostFeedsIdDeleteHardApiResponse = unknown;
export type PostFeedsIdDeleteHardApiArg = {
  id: number;
};
export type PostFeedsIdUndeleteApiResponse = unknown;
export type PostFeedsIdUndeleteApiArg = {
  id: number;
};
export type GetApiCompaniesCompanyIdFeedsApiResponse =
  /** status 200 OK */ FeedForCompanyWeb[];
export type GetApiCompaniesCompanyIdFeedsApiArg = {
  companyId: string;
  includeDeleted?: boolean;
};
export type PatchApiCompaniesCompanyIdFeedsFeedIdApiResponse =
  /** status 200 OK */ FeedForCompanyWeb;
export type PatchApiCompaniesCompanyIdFeedsFeedIdApiArg = {
  feedId: number;
  companyId: string;
  patchFeedForCompanyRequestWeb: PatchFeedForCompanyRequestWeb;
};
export type DeleteApiFeedsIdApiResponse = unknown;
export type DeleteApiFeedsIdApiArg = {
  id: number;
};
export type GetApiFeedsIdApiResponse = /** status 200 OK */ FeedWeb;
export type GetApiFeedsIdApiArg = {
  id: number;
};
export type PatchApiFeedsIdApiResponse = /** status 200 OK */ FeedWeb;
export type PatchApiFeedsIdApiArg = {
  id: number;
  body: Operation[];
};
export type GetApiFeedsApiResponse = /** status 200 OK */ FeedWeb[];
export type GetApiFeedsApiArg = void;
export type PostApiFeedsApiResponse = /** status 200 OK */ FeedWeb;
export type PostApiFeedsApiArg = {
  saveFeedRequestWeb: SaveFeedRequestWeb;
};
export type GetApiFeedsBycompanyCompanyIdApiResponse =
  /** status 200 OK */ FeedWeb[];
export type GetApiFeedsBycompanyCompanyIdApiArg = {
  companyId: string;
};
export type GetApiV2FeedsGetAllForSiteSiteIdNullApiResponse =
  /** status 200 OK */ FeedListWeb;
export type GetApiV2FeedsGetAllForSiteSiteIdNullApiArg = void;
export type GetFeedSuppliersIdApiResponse =
  /** status 200 OK */ FeedSupplierForCompanyWeb;
export type GetFeedSuppliersIdApiArg = {
  id: number;
};
export type PatchFeedSuppliersIdApiResponse =
  /** status 200 OK */ FeedSupplierForCompanyWeb;
export type PatchFeedSuppliersIdApiArg = {
  id: number;
  patchFeedSupplierRequestWeb: PatchFeedSupplierRequestWeb;
};
export type PostFeedSuppliersApiResponse =
  /** status 200 OK */ FeedSupplierForCompanyWeb[];
export type PostFeedSuppliersApiArg = {
  body: CreateFeedSupplierRequestWeb[];
};
export type GetFeedSuppliersApiResponse =
  /** status 200 OK */ FeedSupplierForCompanyWebIEnumerableODataValue;
export type GetFeedSuppliersApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type PostFeedSuppliersIdDeleteApiResponse = unknown;
export type PostFeedSuppliersIdDeleteApiArg = {
  id: number;
};
export type PostFeedSuppliersIdDeleteHardApiResponse = unknown;
export type PostFeedSuppliersIdDeleteHardApiArg = {
  id: number;
};
export type PostFeedSuppliersIdUndeleteApiResponse = unknown;
export type PostFeedSuppliersIdUndeleteApiArg = {
  id: number;
};
export type GetApiV2FeedSuppliersApiResponse =
  /** status 200 OK */ FeedSupplierIEnumerableODataValue;
export type GetApiV2FeedSuppliersApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2FeedSuppliersCountApiResponse =
  /** status 200 OK */ FeedSupplierIEnumerableODataValue;
export type GetApiV2FeedSuppliersCountApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type PostApiFeedSuppliersApiResponse =
  /** status 200 OK */ FeedSupplierWeb;
export type PostApiFeedSuppliersApiArg = {
  saveFeedSupplierRequestWeb: SaveFeedSupplierRequestWeb;
};
export type GetApiFeedSuppliersApiResponse =
  /** status 200 OK */ FeedSupplierWeb[];
export type GetApiFeedSuppliersApiArg = void;
export type PatchApiFeedSuppliersIdApiResponse =
  /** status 200 OK */ FeedSupplierWeb;
export type PatchApiFeedSuppliersIdApiArg = {
  id: number;
  body: Operation[];
};
export type GetApiV2GroupsApiResponse =
  /** status 200 OK */ GroupIEnumerableODataValue;
export type GetApiV2GroupsApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2GroupsCountApiResponse =
  /** status 200 OK */ GroupIEnumerableODataValue;
export type GetApiV2GroupsCountApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2GroupsGetGroupsByCompanyCompanyIdCompanyIdApiResponse =
  /** status 200 OK */ GroupIEnumerableODataValue;
export type GetApiV2GroupsGetGroupsByCompanyCompanyIdCompanyIdApiArg = {
  companyId: string;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2GroupsKeyApiResponse = /** status 200 OK */ GroupRead;
export type GetApiV2GroupsKeyApiArg = {
  key: number;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2GroupsGetGroupsAndDescendantsApiResponse =
  /** status 200 OK */ GroupIEnumerableODataValue;
export type GetApiV2GroupsGetGroupsAndDescendantsApiArg = {
  groupIds?: number[];
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type PostApiV2GroupsApiResponse = /** status 200 OK */ GroupWeb;
export type PostApiV2GroupsApiArg = {
  createGroupRequestWeb: CreateGroupRequestWeb;
};
export type PutApiV2GroupsKeyApiResponse = /** status 200 OK */ GroupWeb;
export type PutApiV2GroupsKeyApiArg = {
  key: number;
  updateGroupRequestWeb: UpdateGroupRequestWeb;
};
export type DeleteApiV2GroupsKeyApiResponse = unknown;
export type DeleteApiV2GroupsKeyApiArg = {
  key: number;
};
export type PostApiV2LevelsPostTreeApiResponse = unknown;
export type PostApiV2LevelsPostTreeApiArg = {
  saveCompanyLevelRequestWeb: SaveCompanyLevelRequestWeb;
};
export type GetApiV2LevelsApiResponse =
  /** status 200 OK */ LevelIEnumerableODataValue;
export type GetApiV2LevelsApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2LevelsCountApiResponse =
  /** status 200 OK */ LevelIEnumerableODataValue;
export type GetApiV2LevelsCountApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2LevelsGetAllForCompanyCompanyIdCompanyIdApiResponse =
  /** status 200 OK */ LevelIEnumerableODataValue;
export type GetApiV2LevelsGetAllForCompanyCompanyIdCompanyIdApiArg = {
  companyId: string;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2LevelsKeyApiResponse = /** status 200 OK */ LevelRead;
export type GetApiV2LevelsKeyApiArg = {
  key: number;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetCompanyPropertiesIdApiResponse =
  /** status 200 OK */ PropertyValueWeb;
export type GetCompanyPropertiesIdApiArg = {
  id: number;
};
export type PatchCompanyPropertiesIdApiResponse =
  /** status 200 OK */ PropertyValueWeb;
export type PatchCompanyPropertiesIdApiArg = {
  id: number;
  patchPropertyValueRequestWeb: PatchPropertyValueRequestWeb;
};
export type GetCompanyPropertiesApiResponse =
  /** status 200 OK */ PropertyValueWeb[];
export type GetCompanyPropertiesApiArg = {
  companyId?: string;
};
export type PostCompanyPropertiesApiResponse =
  /** status 200 OK */ PropertyValueWeb;
export type PostCompanyPropertiesApiArg = {
  createCompanyPropertyRequestWeb: CreateCompanyPropertyRequestWeb;
};
export type PostCompanyPropertiesIdDeleteHardApiResponse = unknown;
export type PostCompanyPropertiesIdDeleteHardApiArg = {
  id: number;
};
export type GetPropertiesIdApiResponse = /** status 200 OK */ PropertyWeb;
export type GetPropertiesIdApiArg = {
  id: number;
};
export type PatchPropertiesIdApiResponse = /** status 200 OK */ PropertyWeb;
export type PatchPropertiesIdApiArg = {
  id: number;
  patchPropertyRequestWeb: PatchPropertyRequestWeb;
};
export type GetPropertiesApiResponse = /** status 200 OK */ PropertyWeb[];
export type GetPropertiesApiArg = void;
export type PostPropertiesApiResponse = /** status 200 OK */ PropertyWeb;
export type PostPropertiesApiArg = {
  createPropertyRequestWeb: CreatePropertyRequestWeb;
};
export type PostPropertiesIdDeleteHardApiResponse = unknown;
export type PostPropertiesIdDeleteHardApiArg = {
  id: number;
};
export type GetSitePropertiesIdApiResponse =
  /** status 200 OK */ PropertyValueWeb;
export type GetSitePropertiesIdApiArg = {
  id: number;
};
export type PatchSitePropertiesIdApiResponse =
  /** status 200 OK */ PropertyValueWeb;
export type PatchSitePropertiesIdApiArg = {
  id: number;
  patchPropertyValueRequestWeb: PatchPropertyValueRequestWeb;
};
export type GetSitePropertiesApiResponse =
  /** status 200 OK */ PropertyValueWeb[];
export type GetSitePropertiesApiArg = {
  siteId?: number;
};
export type PostSitePropertiesApiResponse =
  /** status 200 OK */ PropertyValueWeb;
export type PostSitePropertiesApiArg = {
  createSitePropertyRequestWeb: CreateSitePropertyRequestWeb;
};
export type PostSitePropertiesIdDeleteHardApiResponse = unknown;
export type PostSitePropertiesIdDeleteHardApiArg = {
  id: number;
};
export type GetPublicMetaCompany20230101ApiResponse =
  /** status 200 OK */ CompanySiteBriefInfoWeb2023;
export type GetPublicMetaCompany20230101ApiArg = {
  $include?: string;
};
export type GetPublicMetaCompany20250101ApiResponse =
  /** status 200 OK */ CompanySiteBriefInfoWeb2025;
export type GetPublicMetaCompany20250101ApiArg = {
  include?: string;
};
export type GetPublicMetaSitesId20230101ApiResponse =
  /** status 200 OK */ SiteBriefInfoWeb2023;
export type GetPublicMetaSitesId20230101ApiArg = {
  id: number;
  $include?: string;
};
export type GetPublicMetaSitesId20250101ApiResponse =
  /** status 200 OK */ SiteBriefInfoWeb2025;
export type GetPublicMetaSitesId20250101ApiArg = {
  id: number;
  include?: string;
};
export type GetApiV2SilosApiResponse =
  /** status 200 OK */ SiloIEnumerableODataValue;
export type GetApiV2SilosApiArg = {
  includeDeleted?: boolean;
  includeBargeSilo?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2SilosCountApiResponse =
  /** status 200 OK */ SiloIEnumerableODataValue;
export type GetApiV2SilosCountApiArg = {
  includeDeleted?: boolean;
  includeBargeSilo?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2SilosKeyApiResponse = /** status 200 OK */ SiloRead;
export type GetApiV2SilosKeyApiArg = {
  key: number;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiSitesSiteIdSilosApiResponse = /** status 200 OK */ SiloWeb[];
export type GetApiSitesSiteIdSilosApiArg = {
  siteId: number;
  includeDeleted?: boolean;
};
export type PatchApiSilosIdApiResponse = /** status 200 OK */ SiloWeb;
export type PatchApiSilosIdApiArg = {
  id: number;
  patchSiloRequestWeb: PatchSiloRequestWeb;
};
export type DeleteApiSilosIdApiResponse = unknown;
export type DeleteApiSilosIdApiArg = {
  id: number;
};
export type PostApiSilosApiResponse = /** status 200 OK */ SiloWeb[];
export type PostApiSilosApiArg = {
  body: CreateSiloRequestWeb[];
};
export type GetApiSitesSiteIdSilosAvailableApiResponse =
  /** status 200 OK */ boolean;
export type GetApiSitesSiteIdSilosAvailableApiArg = {
  siteId: number;
  siloName?: string;
  type?: string;
};
export type GetApiV2SitesApiResponse =
  /** status 200 OK */ SiteIEnumerableODataValueRead;
export type GetApiV2SitesApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2SitesCountApiResponse =
  /** status 200 OK */ SiteIEnumerableODataValueRead;
export type GetApiV2SitesCountApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2SitesKeyApiResponse = /** status 200 OK */ SiteRead;
export type GetApiV2SitesKeyApiArg = {
  key: number;
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiSitesApiResponse =
  /** status 200 OK */ SiteCompanyBriefInfoWeb[];
export type GetApiSitesApiArg = void;
export type PostApiSitesApiResponse = /** status 201 Created */ SiteWeb;
export type PostApiSitesApiArg = {
  createSiteRequestWeb: CreateSiteRequestWeb;
};
export type GetApiCompaniesCompanyIdSitesApiResponse =
  /** status 200 OK */ SiteByCompanyWeb[];
export type GetApiCompaniesCompanyIdSitesApiArg = {
  companyId: string;
  /** A filter for sites that were changed after the specified date. */
  changedAfter?: string;
  /** A flag indicating whether to include deleted sites in the response. */
  includeDeleted?: boolean;
};
export type GetApiSitesIdApiResponse = /** status 200 OK */ SiteWeb;
export type GetApiSitesIdApiArg = {
  id: number;
  include?: SiteIncludeQueryWeb[];
};
export type PutApiSitesIdApiResponse = /** status 200 OK */ SiteWeb;
export type PutApiSitesIdApiArg = {
  id: number;
  updateSiteRequestWeb: UpdateSiteRequestWeb;
};
export type PatchApiSitesIdApiResponse = /** status 200 OK */ SiteWeb;
export type PatchApiSitesIdApiArg = {
  id: number;
  patchSiteRequestWeb: PatchSiteRequestWeb;
};
export type DeleteApiSitesIdApiResponse = unknown;
export type DeleteApiSitesIdApiArg = {
  id: number;
};
export type GetApiSitesSelfIdApiResponse =
  /** status 200 OK */ SiteBriefInfoWeb;
export type GetApiSitesSelfIdApiArg = {
  id: number;
  $include?: string;
};
export type GetApiStationLicenseBillingGroupsSiteIdApplicationIdApiResponse =
  /** status 200 OK */ StationLicenseBillingGroupWeb;
export type GetApiStationLicenseBillingGroupsSiteIdApplicationIdApiArg = {
  siteId: number;
  applicationId: string;
};
export type PutApiStationLicenseBillingGroupsSiteIdApplicationIdApiResponse =
  /** status 200 OK */ StationLicenseBillingGroupWeb;
export type PutApiStationLicenseBillingGroupsSiteIdApplicationIdApiArg = {
  siteId: number;
  applicationId: string;
  putStationLicenseBillingGroupRequestWeb: PutStationLicenseBillingGroupRequestWeb;
};
export type GetApiV2StationLicensesApiResponse =
  /** status 200 OK */ StationLicenseIEnumerableODataValueRead;
export type GetApiV2StationLicensesApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2StationLicensesCountApiResponse =
  /** status 200 OK */ StationLicenseIEnumerableODataValueRead;
export type GetApiV2StationLicensesCountApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2StationLicensesKeyApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type GetApiV2StationLicensesKeyApiArg = {
  key: number;
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2StationLicensesGetAllGroupedBySiteAndProductApiResponse =
  /** status 200 OK */ SiteAndProductStationLicenseGroupWebIEnumerableODataValue;
export type GetApiV2StationLicensesGetAllGroupedBySiteAndProductApiArg = {
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2StationLicensesGetAllGroupedByApplicationAndSwVersionApiResponse =
  /** status 200 OK */ StationLicensesGroupedByApplicationAndSwVersionWebIReadOnlyListODataValue;
export type GetApiV2StationLicensesGetAllGroupedByApplicationAndSwVersionApiArg =
  {
    /** The max number of records. */
    $top?: number;
    /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
    $apply?: string;
    /** The number of records to skip. */
    $skip?: number;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: string;
    /** Specifies a subset of properties to return. Use a comma separated list. */
    $select?: string;
    /** Determines what values are used to order a collection of records. */
    $orderby?: string;
    /** Use to add related query data. */
    $expand?: string;
    /** Allows clients to request a count of the matching resources included with the resources in the response. */
    $count?: boolean;
  };
export type GetApiStationLicensesAuthApiResponse =
  /** status 200 OK */ StationLicenseAuthResponseWebRead;
export type GetApiStationLicensesAuthApiArg = void;
export type PostApiStationLicensesAuthApiResponse =
  /** status 200 Validation successful */ LicenseLegacyAuthResultWeb;
export type PostApiStationLicensesAuthApiArg = {
  authorizeStationLicenseRequestWeb: AuthorizeStationLicenseRequestWeb;
};
export type GetApiStationLicensesApiResponse =
  /** status 200 OK */ StationLicenseRead[];
export type GetApiStationLicensesApiArg = void;
export type PutApiStationLicensesApiResponse =
  /** status 200 OK */ StationLicenseRead[];
export type PutApiStationLicensesApiArg = {
  body: UpdateStationLicenseRequestWeb[];
};
export type DeleteApiStationLicensesApiResponse = unknown;
export type DeleteApiStationLicensesApiArg = {
  ids?: number[];
};
export type GetApiStationLicensesCompanyCompanyIdApiResponse =
  /** status 200 OK */ StationLicenseRead[];
export type GetApiStationLicensesCompanyCompanyIdApiArg = {
  companyId: string;
};
export type GetApiStationLicensesIdApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type GetApiStationLicensesIdApiArg = {
  id: number;
};
export type PutApiStationLicensesIdApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type PutApiStationLicensesIdApiArg = {
  id: number;
  updateStationLicenseRequestWeb: UpdateStationLicenseRequestWeb;
};
export type PostApiStationLicensesStatusApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type PostApiStationLicensesStatusApiArg = {
  statusStationLicenseRequestWeb: StatusStationLicenseRequestWeb;
};
export type PostApiStationLicensesActivatelicenseApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type PostApiStationLicensesActivatelicenseApiArg = {
  activateStationLicenseRequestWeb: ActivateStationLicenseRequestWeb;
};
export type PostApiStationLicensesCreateactivationcodeApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type PostApiStationLicensesCreateactivationcodeApiArg = {
  createStationLicenseActivationCodeRequestWeb: CreateStationLicenseActivationCodeRequestWeb;
};
export type PostApiStationLicensesCreateactivationcodesApiResponse =
  /** status 200 OK */ CreatedActivationCodesWebRead;
export type PostApiStationLicensesCreateactivationcodesApiArg = {
  body: CreateStationLicenseActivationCodeRequestWeb[];
};
export type PostApiStationLicensesCreatelicensekeyApiResponse =
  /** status 200 OK */ CreatedLicenseKeyWebRead;
export type PostApiStationLicensesCreatelicensekeyApiArg = {
  createStationLicenseKeyRequestWeb: CreateStationLicenseKeyRequestWeb;
};
export type PostApiStationLicensesCreatelicensekeysApiResponse =
  /** status 200 OK */ CreatedLicenseKeysWebRead;
export type PostApiStationLicensesCreatelicensekeysApiArg = {
  body: CreateStationLicenseKeyRequestWeb[];
};
export type PutApiStationLicensesIdVersionApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type PutApiStationLicensesIdVersionApiArg = {
  id: number;
  updateStationLicenseVersionRequestWeb: UpdateStationLicenseVersionRequestWeb;
};
export type PutApiStationLicensesIdCategoriesApiResponse =
  /** status 200 OK */ StationLicenseRead;
export type PutApiStationLicensesIdCategoriesApiArg = {
  id: number;
  updateStationLicenseCategoryWeb: UpdateStationLicenseCategoryWeb;
};
export type PostApiV2TenantsApiResponse = /** status 200 OK */ TenantRead;
export type PostApiV2TenantsApiArg = {
  updateTenantRequestWeb: UpdateTenantRequestWeb;
};
export type GetApiV2TenantsApiResponse =
  /** status 200 OK */ TenantIEnumerableODataValue;
export type GetApiV2TenantsApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2TenantsCountApiResponse =
  /** status 200 OK */ TenantIEnumerableODataValue;
export type GetApiV2TenantsCountApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2TenantsKeyApiResponse =
  /** status 200 OK */ TenantODataValue;
export type GetApiV2TenantsKeyApiArg = {
  key: number;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type PutApiV2TenantsKeyApiResponse = unknown;
export type PutApiV2TenantsKeyApiArg = {
  key: number;
  updateTenantRequestWeb: UpdateTenantRequestWeb;
};
export type DeleteApiV2TenantsKeyApiResponse = unknown;
export type DeleteApiV2TenantsKeyApiArg = {
  key: number;
};
export type GetApiSitesSiteIdUnitgroupsApiResponse =
  /** status 200 OK */ UnitGroupRead[];
export type GetApiSitesSiteIdUnitgroupsApiArg = {
  siteId: number;
  includeUnit?: boolean;
};
export type PostApiSitesSiteIdUnitgroupsApiResponse =
  /** status 201 Created */ UnitGroupRead;
export type PostApiSitesSiteIdUnitgroupsApiArg = {
  siteId: number;
  createUnitGroupRequestWeb: CreateUnitGroupRequestWeb;
};
export type PutApiSitesSiteIdUnitgroupsIdApiResponse = unknown;
export type PutApiSitesSiteIdUnitgroupsIdApiArg = {
  siteId: number;
  id: number;
  updateUnitGroupRequestWeb: UpdateUnitGroupRequestWeb;
};
export type DeleteApiSitesSiteIdUnitgroupsIdApiResponse = unknown;
export type DeleteApiSitesSiteIdUnitgroupsIdApiArg = {
  siteId: number;
  id: number;
};
export type PostApiSitesSiteIdUnitgroupsAllApiResponse = unknown;
export type PostApiSitesSiteIdUnitgroupsAllApiArg = {
  siteId: number;
  body: UpdateUnitGroupRequestWeb[];
};
export type GetApiV2UnitsApiResponse =
  /** status 200 OK */ UnitIEnumerableODataValueRead;
export type GetApiV2UnitsApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2UnitsCountApiResponse =
  /** status 200 OK */ UnitIEnumerableODataValueRead;
export type GetApiV2UnitsCountApiArg = {
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiV2UnitsKeyApiResponse = /** status 200 OK */ UnitRead;
export type GetApiV2UnitsKeyApiArg = {
  key: number;
  includeDeleted?: boolean;
  /** The max number of records. */
  $top?: number;
  /** Allows to specify a sequence of transformations to the entity set, such as groupby, filter, aggregate, etc. */
  $apply?: string;
  /** The number of records to skip. */
  $skip?: number;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Specifies a subset of properties to return. Use a comma separated list. */
  $select?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Allows clients to request a count of the matching resources included with the resources in the response. */
  $count?: boolean;
};
export type GetApiSitesSiteIdUnitsApiResponse = /** status 200 OK */ UnitWeb[];
export type GetApiSitesSiteIdUnitsApiArg = {
  siteId: number;
  /** A filter for entities that were changed after the specified date. */
  changedAfter?: string;
  /** A flag indicating if deleted entities should be included. */
  includeDeleted?: boolean;
};
export type PostApiSitesSiteIdUnitsApiResponse = /** status 200 OK */ UnitWeb[];
export type PostApiSitesSiteIdUnitsApiArg = {
  siteId: number;
  body: CreateUnitRequestWeb[];
};
export type GetApiSitesSiteIdUnitsUnitIdApiResponse =
  /** status 200 OK */ UnitWeb;
export type GetApiSitesSiteIdUnitsUnitIdApiArg = {
  siteId: number;
  unitId: number;
};
export type PutApiSitesSiteIdUnitsUnitIdApiResponse = unknown;
export type PutApiSitesSiteIdUnitsUnitIdApiArg = {
  unitId: number;
  siteId: string;
  updateUnitRequestWeb: UpdateUnitRequestWeb;
};
export type PatchApiSitesSiteIdUnitsUnitIdApiResponse =
  /** status 200 OK */ UnitWeb;
export type PatchApiSitesSiteIdUnitsUnitIdApiArg = {
  unitId: number;
  siteId: string;
  patchUnitRequestWeb: PatchUnitRequestWeb;
};
export type PostApiSitesSiteIdUnitsAllApiResponse =
  /** status 200 OK */ UnitWeb[];
export type PostApiSitesSiteIdUnitsAllApiArg = {
  siteId: number;
  body: SaveUnitRequestWeb[];
};
export type DeleteApiSitesSiteIdUnitsIdApiResponse = unknown;
export type DeleteApiSitesSiteIdUnitsIdApiArg = {
  id: number;
  siteId: string;
};
export type GetApiUnitsShapesApiResponse = /** status 200 OK */ string[];
export type GetApiUnitsShapesApiArg = void;
export type GetApiUnitsModelsApiResponse = /** status 200 OK */ UnitModelWeb[];
export type GetApiUnitsModelsApiArg = void;
export type GetApiSitesSiteIdUnitsAvailableApiResponse =
  /** status 200 OK */ boolean;
export type GetApiSitesSiteIdUnitsAvailableApiArg = {
  siteId: number;
  unitName: string;
  type?: string;
};
export type GetApiSitesSiteIdUnitsUnitIdHistoryApiResponse =
  /** status 200 OK */ AuditWeb[];
export type GetApiSitesSiteIdUnitsUnitIdHistoryApiArg = {
  siteId: number;
  unitId: number;
};
export type GetApiUserAccessSitesApiResponse =
  /** status 200 OK */ BriefSiteWeb[];
export type GetApiUserAccessSitesApiArg = {
  siteIds?: number[];
};
export type GetApiUserAccessSitesbygroupApiResponse =
  /** status 200 OK */ BriefSiteWeb[];
export type GetApiUserAccessSitesbygroupApiArg = {
  groupIds?: number[];
};
export type ApplicationWeb = {
  applicationId: string;
  applicationName: string;
};
export type SaveApplicationRequestWeb = {
  applicationId: string;
  applicationName: string;
};
export type ApplicationVersionWeb = {
  companyId: string;
  companyName: string;
  applicationId: string;
  applicationName: string;
  version: string;
  createdDateTime: string;
  lastActive: string | null;
};
export type SaveApplicationVersionRequestWeb = {
  companyId: string;
  version: string;
};
export type ApplicationVersionRequestWeb = {
  applicationId: string;
  companyId: string;
  version: string;
};
export type Level = {
  levelId?: number;
  name: string;
  companyId: string;
  company?: Company;
  parent?: Level;
  parentId?: number | null;
  children?: Level[];
  groups?: Group[];
};
export type LevelRead = {
  levelId?: number;
  name: string;
  companyId: string;
  company?: Company;
  parent?: LevelRead;
  parentId?: number | null;
  children?: LevelRead[];
  groups?: Group[];
};
export type Group = {
  groupId?: number;
  name: string;
  levelId?: number;
  level?: Level;
  parentId?: number | null;
  children?: Group[];
  sites?: Site[];
};
export type GroupRead = {
  groupId?: number;
  name: string;
  levelId?: number;
  level?: LevelRead;
  parentId?: number | null;
  children?: GroupRead[];
  sites?: Site[];
};
export type UnitShape = "Rectangular" | "Round";
export type UnitModel = {
  id?: number;
  displayName: string;
  width?: number;
  depth?: number;
  volume?: number | null;
  unitShape?: UnitShape;
  units?: Unit[];
};
export type UnitModelRead = {
  id?: number;
  displayName: string;
  width?: number;
  depth?: number;
  volume?: number | null;
  unitShape?: UnitShape;
  units?: Unit[];
};
export type UnitGroup = {
  unitGroupId?: number;
  siteId?: number;
  site?: Site;
  name: string;
  color?: string | null;
  units?: Unit[];
};
export type UnitGroupRead = {
  unitGroupId?: number;
  siteId?: number;
  site?: Site;
  name: string;
  color?: string | null;
  units?: Unit[];
};
export type AuditIdentityType = "User" | "ApiUser" | "License" | "Application";
export type Unit = {
  unitId?: number;
  unitName: string;
  unitCode?: string | null;
  siteId?: number;
  site?: Site;
  width?: number | null;
  depth?: number | null;
  volume?: number | null;
  seabed?: number | null;
  unitModelId?: number | null;
  unitModel?: UnitModel;
  longitude?: number | null;
  latitude?: number | null;
  unitShape?: UnitShape;
  deActivatedInFarmer?: string | null;
  deActivedInFeedStation?: string | null;
  deletedInFarmer?: string | null;
  deletedInFeedStation?: string | null;
  deactivated?: boolean;
  deleted?: boolean;
  unitGroupId?: number | null;
  unitGroup?: UnitGroup;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type UnitRead = {
  unitId?: number;
  unitName: string;
  unitCode?: string | null;
  siteId?: number;
  site?: Site;
  width?: number | null;
  depth?: number | null;
  volume?: number | null;
  seabed?: number | null;
  unitModelId?: number | null;
  unitModel?: UnitModelRead;
  longitude?: number | null;
  latitude?: number | null;
  unitShape?: UnitShape;
  deActivatedInFarmer?: string | null;
  deActivedInFeedStation?: string | null;
  deletedInFarmer?: string | null;
  deletedInFeedStation?: string | null;
  deactivated?: boolean;
  deleted?: boolean;
  updated?: string | null;
  unitGroupId?: number | null;
  unitGroup?: UnitGroupRead;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type SiloContentOrder = "FIFO" | "UNORDERED";
export type Silo = {
  siloId?: number;
  siloName: string;
  siloCode?: string | null;
  siteId?: number | null;
  site?: Site;
  bargeId?: number | null;
  barge?: Barge;
  capacity?: number;
  deActivatedInFarmer?: string | null;
  deActivedInFeedStation?: string | null;
  deletedInFarmer?: string | null;
  deletedInFeedStation?: string | null;
  contentOrder?: SiloContentOrder;
  deactivated?: boolean;
  deleted?: boolean;
  onShore?: boolean;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type SiloRead = {
  siloId?: number;
  siloName: string;
  siloCode?: string | null;
  siteId?: number | null;
  site?: Site;
  bargeId?: number | null;
  barge?: Barge;
  capacity?: number;
  deActivatedInFarmer?: string | null;
  deActivedInFeedStation?: string | null;
  deletedInFarmer?: string | null;
  deletedInFeedStation?: string | null;
  contentOrder?: SiloContentOrder;
  deactivated?: boolean;
  deleted?: boolean;
  onShore?: boolean;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type EntityType = "Site" | "Company";
export type PropertyType = "Int" | "Float" | "String" | "Hidden" | "Toggle";
export type AdditionalDetailsProperty = {
  id?: number;
  countryCode?: string | null;
  propertyName: string;
  entityType?: EntityType;
  propertyType?: PropertyType;
  createdDateTime?: string;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type AdditionalSitePropertyValue = {
  id?: number;
  value?: string | null;
  additionalDetailsPropertyId?: number;
  additionalDetailsProperty?: AdditionalDetailsProperty;
  siteId?: number;
  site?: Site;
  createdDateTime?: string;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type AdditionalSitePropertyValueRead = {
  id?: number;
  value?: string | null;
  additionalDetailsPropertyId?: number;
  additionalDetailsProperty?: AdditionalDetailsProperty;
  siteId?: number;
  site?: Site;
  createdDateTime?: string;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type Site = {
  siteId?: number;
  siteCode?: string | null;
  siteName: string;
  siteType: string;
  license?: string | null;
  maxTotalBiomass?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  timezone: string;
  farmerCode?: string | null;
  deActivatedInFarmer?: string | null;
  deActivedInFeedStation?: string | null;
  deletedInFarmer?: string | null;
  deletedInFeedStation?: string | null;
  deleted?: boolean;
  companyId: string;
  company?: Company;
  associatedCompanyId?: string | null;
  associatedCompany?: Company;
  groupId?: number | null;
  group?: Group;
  units?: Unit[] | null;
  silos?: Silo[] | null;
  barges?: Barge[] | null;
  additionalPropertyValues?: AdditionalSitePropertyValue[] | null;
  prefixIpAddress?: string | null;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type SiteRead = {
  siteId?: number;
  siteCode?: string | null;
  siteName: string;
  siteType: string;
  license?: string | null;
  maxTotalBiomass?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  timezone: string;
  farmerCode?: string | null;
  deActivatedInFarmer?: string | null;
  deActivedInFeedStation?: string | null;
  deletedInFarmer?: string | null;
  deletedInFeedStation?: string | null;
  deleted?: boolean;
  deactivated?: boolean;
  companyId: string;
  company?: Company;
  associatedCompanyId?: string | null;
  associatedCompany?: Company;
  groupId?: number | null;
  group?: GroupRead;
  units?: UnitRead[] | null;
  silos?: SiloRead[] | null;
  barges?: Barge[] | null;
  additionalPropertyValues?: AdditionalSitePropertyValueRead[] | null;
  prefixIpAddress?: string | null;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type AdditionalCompanyPropertyValue = {
  id?: number;
  value?: string | null;
  additionalDetailsPropertyId?: number;
  additionalDetailsProperty?: AdditionalDetailsProperty;
  companyId: string;
  company?: Company;
  createdDateTime?: string;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type AdditionalCompanyPropertyValueRead = {
  id?: number;
  value?: string | null;
  additionalDetailsPropertyId?: number;
  additionalDetailsProperty?: AdditionalDetailsProperty;
  companyId: string;
  company?: Company;
  createdDateTime?: string;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type FeedCompany = {
  feedCompanyId?: number;
  feedId?: number;
  companyId: string;
  name?: string | null;
  active?: boolean;
  isDeleted?: boolean;
  color?: string | null;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type FeedSupplier = {
  feedSupplierId?: number;
  name: string;
  isDeleted?: boolean;
  companyFeedSuppliers?: CompanyFeedSupplier[];
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type CompanyFeedSupplier = {
  companyId: string;
  company?: Company;
  feedSupplierId?: number;
  feedSupplier?: FeedSupplier;
};
export type CompanyFeedSupplierRead = {
  companyId: string;
  company?: Company;
  feedSupplierId?: number;
  feedSupplier?: FeedSupplier;
};
export type Tenant = {
  tenantId?: number;
  name: string;
  companyId: string;
  company?: Company;
};
export type TenantRead = {
  tenantId?: number;
  name: string;
  companyId: string;
  company?: Company;
};
export type PriceModel = "Standard" | "Mowi";
export type Company = {
  companyId: string;
  companyName: string;
  companyCode?: string | null;
  countryCode: string;
  deleted?: boolean;
  parentCompanyId?: string | null;
  parentCompany?: Company;
  ownedCompanies?: Company[] | null;
  sites?: Site[] | null;
  additionalPropertyValues?: AdditionalCompanyPropertyValue[] | null;
  companyFeeds?: FeedCompany[];
  companyFeedSuppliers?: CompanyFeedSupplier[];
  tenants?: Tenant[];
  timezone: string;
  customerAccountNumber?: string | null;
  createdDateTime?: string;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
  priceModel?: PriceModel;
};
export type CompanyRead = {
  companyId: string;
  companyName: string;
  companyCode?: string | null;
  countryCode: string;
  deleted?: boolean;
  parentCompanyId?: string | null;
  parentCompany?: CompanyRead;
  ownedCompanies?: CompanyRead[] | null;
  sites?: SiteRead[] | null;
  additionalPropertyValues?: AdditionalCompanyPropertyValueRead[] | null;
  companyFeeds?: FeedCompany[];
  companyFeedSuppliers?: CompanyFeedSupplierRead[];
  tenants?: TenantRead[];
  timezone: string;
  customerAccountNumber?: string | null;
  createdDateTime?: string;
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
  priceModel?: PriceModel;
};
export type BargeModel = {
  bargeModelId?: number;
  bargeModelName: string;
  siloQuantity?: number;
  siloCapacity?: number;
};
export type Barge = {
  bargeId?: number;
  bargeName: string;
  companyId: string;
  company?: Company;
  bargeModelId?: number | null;
  model?: BargeModel;
  siteId?: number | null;
  site?: Site;
  extraStorage?: boolean;
  activeFrom?: string;
  deleted?: boolean;
  deactivated?: boolean;
  silos?: Silo[];
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type BargeRead = {
  bargeId?: number;
  bargeName: string;
  companyId: string;
  company?: CompanyRead;
  bargeModelId?: number | null;
  model?: BargeModel;
  siteId?: number | null;
  site?: SiteRead;
  extraStorage?: boolean;
  activeFrom?: string;
  deleted?: boolean;
  deactivated?: boolean;
  silos?: SiloRead[];
  changedDateTime?: string;
  changedById?: string | null;
  changedByType?: AuditIdentityType;
};
export type BargeHistory = {
  bargeHistoryId?: number;
  bargeId?: number;
  barge?: Barge;
  activeFrom?: string;
  updatedDate?: string;
  updater?: string | null;
  field?: string | null;
  value?: string | null;
};
export type BargeHistoryIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: BargeHistory[] | null;
};
export type BargeModelIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: BargeModel[] | null;
};
export type BargeIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Barge[] | null;
};
export type CreateBargeSiloRequestWeb = {
  siloName: string;
  siloCode?: string | null;
  capacity?: number;
};
export type CreateBargeRequestWeb = {
  bargeName: string;
  companyId: string;
  siteId?: number | null;
  bargeModelId?: number | null;
  extraStorage?: boolean;
  activeFrom?: string;
  silos?: CreateBargeSiloRequestWeb[];
};
export type UpdateBargeSiloRequestWeb = {
  siloId: number;
  siloName: string;
  siloCode?: string | null;
  capacity?: number;
};
export type UpdateBargeRequestWeb = {
  bargeId: number;
  bargeName: string;
  companyId: string;
  siteId?: number | null;
  bargeModelId?: number | null;
  extraStorage?: boolean;
  activeFrom?: string;
  deleted?: boolean;
  deactivated?: boolean;
  silos?: UpdateBargeSiloRequestWeb[];
};
export type CompanyIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Company[] | null;
};
export type CompanyIEnumerableODataValueRead = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: CompanyRead[] | null;
};
export type CreateCompanyRequestWeb = {
  companyName: string;
  companyCode?: string | null;
  countryCode: string;
  timezone: string;
  customerAccountNumber?: string | null;
  parentCompanyId?: string | null;
  priceModel?: PriceModel;
};
export type SimpleSiteWeb = {
  siteId?: number;
  siteName: string;
  siteCode: string | null;
  deactivated: boolean;
};
export type SimpleCompanyWeb = {
  companyId: string;
  companyName: string;
  companyCode?: string | null;
  sites: SimpleSiteWeb[];
};
export type UnitWeb = {
  unitId: number;
  unitName: string;
  unitCode: string | null;
  siteId: number;
  width: number | null;
  depth: number | null;
  volume: number | null;
  seabed: number | null;
  unitModelId: number | null;
  longitude: number | null;
  latitude: number | null;
  deactivated: boolean;
  deleted: boolean;
  unitShape: UnitShape;
  unitGroupId: number | null;
  deActivatedInFarmer: string | null;
  deActivedInFeedStation: string | null;
  deletedInFarmer: string | null;
  deletedInFeedStation: string | null;
  /** A datetime when the unit was last changed */
  changedDateTime: string;
};
export type SiloWeb = {
  siloId: number;
  siloName: string;
  siloCode: string | null;
  siteId: number | null;
  bargeId: number | null;
  capacity: number;
  contentOrder: SiloContentOrder;
  onShore: boolean;
  deactivated: boolean;
  deleted: boolean;
};
export type AdditionalPropertyValueWeb = {
  id: number;
  value: string | null;
  propertyName: string;
  additionalDetailsPropertyId: number;
  createdDateTime: string;
  changedDateTime: string;
  changedById: string | null;
};
export type SiteWeb = {
  siteId: number;
  siteCode: string | null;
  siteName: string;
  siteType: string;
  license: string | null;
  timezone: string;
  maxTotalBiomass: number | null;
  longitude: number | null;
  latitude: number | null;
  companyId: string;
  companyName: string;
  groupId: number | null;
  deleted: boolean;
  farmerCode: string | null;
  units: UnitWeb[] | null;
  silos: SiloWeb[] | null;
  additionalPropertyValues: AdditionalPropertyValueWeb[] | null;
};
export type CompanyWeb = {
  companyId: string;
  companyName: string;
  companyCode?: string | null;
  countryCode: string;
  deleted?: boolean;
  parentCompanyName?: string | null;
  parentCompanyId?: string | null;
  parentCompany?: CompanyWeb;
  sites?: SiteWeb[] | null;
  additionalPropertyValues?: AdditionalPropertyValueWeb[] | null;
  timezone: string;
  customerAccountNumber?: string | null;
};
export type CompanyIncludeQueryWeb =
  | "AdditionalDetails"
  | "Sites"
  | "SiteUnits"
  | "SiteSilos"
  | "SiteAdditionalDetails";
export type UpdateCompanyRequestWeb = {
  companyName: string;
  companyCode?: string | null;
  countryCode: string;
  parentCompanyId?: string | null;
  timezone: string;
  deleted?: boolean;
  customerAccountNumber?: string | null;
  priceModel?: PriceModel;
};
export type PartialUpdateRequestWeb = object;
export type StringOptional = string;
export type BooleanOptional = boolean;
export type PriceModelNullableOptional = any;
export type PatchCompanyRequestWeb = PartialUpdateRequestWeb & {
  companyName?: StringOptional;
  companyCode?: StringOptional;
  countryCode?: StringOptional;
  parentCompanyId?: StringOptional;
  timezone?: StringOptional;
  deleted?: BooleanOptional;
  customerAccountNumber?: StringOptional;
  priceModel?: PriceModelNullableOptional;
};
export type SiteBriefInfoDetailsWeb = {
  longitude?: number | null;
  latitude?: number | null;
  type: string;
  code: string | null;
  license?: string | null;
  maxTotalBiomass?: number | null;
  timezone: string;
};
export type UnitBriefInfoWeb = {
  unitId?: number;
  unitName: string;
  longitude?: number | null;
  latitude?: number | null;
};
export type SiloBriefInfoWeb = {
  siloId: number;
  siloName: string;
  capacity: number;
  contentOrder: string;
};
export type SiteBriefInfoWeb = {
  siteId?: number;
  siteName: string;
  info?: SiteBriefInfoDetailsWeb;
  units?: UnitBriefInfoWeb[] | null;
  silos?: SiloBriefInfoWeb[] | null;
  additionalPropertyValues?: AdditionalPropertyValueWeb[] | null;
};
export type CompanySiteBriefInfoWeb = {
  companyId: string;
  licenseId: number | null;
  companyName: string;
  sites?: SiteBriefInfoWeb[] | null;
  additionalPropertyValues?: AdditionalPropertyValueWeb[] | null;
};
export type CompanyHierarchyWeb = {
  companyId: string;
  companyName: string;
  companyCode: string | null;
  countryCode: string;
  deleted: boolean;
  ownedCompanies: CompanyHierarchyWeb[];
  sites: SiteWeb[] | null;
  additionalPropertyValues: AdditionalPropertyValueWeb[] | null;
  timezone: string;
  customerAccountNumber: string | null;
};
export type SiteWebSma = {
  siteId?: number;
  siteCode: string | null;
  siteName: string;
  siteType: string;
  license?: string | null;
  timezone: string;
  maxTotalBiomass?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  groupId?: number | null;
  associatedCompany?: CompanyWeb;
  units?: UnitWeb[];
  silos?: SiloWeb[];
  additionalPropertyValues?: AdditionalPropertyValueWeb[];
};
export type CompanyWebSma = {
  companyId: string;
  companyName: string;
  companyCode?: string | null;
  countryCode: string;
  timezone: string;
  sites?: SiteWebSma[];
  additionalPropertyValues?: AdditionalPropertyValueWeb[];
};
export type FeedCompanyIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: FeedCompany[] | null;
};
export type FeedForCompanyWeb = {
  /** A unique identifier of the feed */
  feedId: number;
  /** A unique identifier of the company */
  companyId: string;
  /** A unique identifier of the feed supplier */
  feedSupplierId: number;
  /** Name of the feed */
  name: string;
  /** Description of the feed */
  description: string | null;
  /** A size of the feed */
  size: number;
  /** Energy of the feed */
  energy: number;
  /** Indicates if the feed is medicated */
  isMedicated: boolean;
  /** A code in an external system */
  externalItemId: string | null;
  /** Amount of pellets per kilogram */
  pelletPerKg: number;
  /** Indicates if the feed is a cleaner fish feed */
  isCleanerFish: boolean;
  /** A color of the feed */
  color: string | null;
  /** Is Active */
  active: boolean;
  /** Is Deleted */
  isDeleted: boolean;
  /** A datetime when the feed was last changed */
  changedDateTime: string;
  /** An identifier of the identity that made the modification */
  changedById: string | null;
};
export type Int32NullableOptional = number | null;
export type DoubleNullableOptional = number | null;
export type DoubleOptional = number;
export type PatchFeedForCompanyRequestWeb = PartialUpdateRequestWeb & {
  name?: StringOptional;
  description?: StringOptional;
  feedSupplierId?: Int32NullableOptional;
  color?: StringOptional;
  size?: DoubleNullableOptional;
  energy?: DoubleNullableOptional;
  isMedicated?: BooleanOptional;
  astaLevel?: DoubleOptional;
  dryEquivalent?: DoubleOptional;
  externalItemId?: StringOptional;
  code?: StringOptional;
  pelletPerKg?: DoubleOptional;
  isCleanerFish?: BooleanOptional;
};
export type CreateFeedForCompanyRequestWeb = {
  feedSupplierId: number;
  companyId: string;
  name: string;
  size: number;
  energy: number;
  astaLevel: number;
  isMedicated?: boolean;
  dryEquivalent?: number;
  externalItemId?: string | null;
  code?: string | null;
  description?: string | null;
  pelletPerKg?: number;
  isCleanerFish?: boolean;
  color?: string | null;
};
export type FeedForCompanyWebIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** Gets or sets the OData response content in the "value". */
  value: FeedForCompanyWeb[] | null;
};
export type FeedCompanyWeb = {
  companyId: string;
};
export type FeedWeb = {
  feedId: number;
  feedSupplierId: number;
  description: string | null;
  officialName: string;
  size: number;
  energy: number;
  isMedicated: boolean;
  astaLevel: number;
  dryEquivalent: number;
  externalItemId: string | null;
  code: string | null;
  pelletPerKg: number;
  isCleanerFish: boolean;
  feedCompanies: FeedCompanyWeb[];
  active: boolean;
  isSystem: boolean;
  isDeleted: boolean;
  /** A datetime when the feed was last changed */
  changedDateTime?: string;
  /** An identifier of the identity that made the modification */
  changedById?: string | null;
};
export type OperationType =
  | "Add"
  | "Remove"
  | "Replace"
  | "Move"
  | "Copy"
  | "Test"
  | "Invalid";
export type Operation = {
  operationType?: OperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any | null;
};
export type SaveFeedCompanyRequestWeb = {
  companyId: string;
  name?: string | null;
  active?: boolean;
  isDeleted?: boolean;
  color?: string | null;
};
export type SaveFeedRequestWeb = {
  feedId?: number | null;
  feedSupplierId: number;
  officialName: string;
  size: number;
  energy: number;
  isMedicated?: boolean;
  astaLevel: number;
  dryEquivalent?: number;
  externalItemId?: string | null;
  code?: string | null;
  description?: string | null;
  pelletPerKg?: number;
  isCleanerFish?: boolean;
  active?: boolean;
  isSystem?: boolean;
  isDeleted?: boolean;
  feedCompanies?: SaveFeedCompanyRequestWeb[];
};
export type FeedListWeb = {
  value: FeedWeb[];
};
export type FeedSupplierForCompanyWeb = {
  /** A unique identifier of the feed supplier */
  feedSupplierId: number;
  /** Company associated with this feed supplier */
  companyId: string;
  /** A name of the feed supplier */
  name: string;
  /** A flag indicating if the feed supplier is deleted */
  isDeleted: boolean;
  /** A datetime when the entity was last changed */
  changedDateTime: string;
  /** An identifier of the identity that made the modification */
  changedById: string | null;
};
export type PatchFeedSupplierRequestWeb = PartialUpdateRequestWeb & {
  name?: StringOptional;
};
export type CreateFeedSupplierRequestWeb = {
  name: string;
  companyId: string;
};
export type FeedSupplierForCompanyWebIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** Gets or sets the OData response content in the "value". */
  value: FeedSupplierForCompanyWeb[] | null;
};
export type FeedSupplierIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: FeedSupplier[] | null;
};
export type FeedSupplierCompanyWeb = {
  companyId: string;
};
export type FeedSupplierWeb = {
  /** A unique identifier of the feed supplier */
  feedSupplierId: number;
  /** A name of the feed supplier */
  name: string;
  /** A flag indicating if the feed supplier is deleted */
  isDeleted: boolean;
  /** Companies associated with this feed supplier */
  companyFeedSuppliers?: FeedSupplierCompanyWeb[] | null;
  /** A datetime when the entity was last changed */
  changedDateTime: string;
  /** An identifier of the identity that made the modification */
  changedById: string | null;
};
export type FeedSupplierCompanyRequestWeb = {
  companyId: string;
};
export type SaveFeedSupplierRequestWeb = {
  feedSupplierId?: number | null;
  name: string;
  isDeleted?: boolean;
  companyFeedSuppliers?: FeedSupplierCompanyRequestWeb[];
};
export type GroupIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Group[] | null;
};
export type LevelWeb = {
  levelId: number;
  name: string;
  companyId: string;
  companyName: string;
  parentId?: number | null;
};
export type GroupWeb = {
  groupId: number;
  name: string;
  levelId: number;
  level: LevelWeb;
  parentId?: number | null;
  siteIds?: number[];
};
export type CreateGroupRequestWeb = {
  name: string;
  levelId: number;
  parentId?: number | null;
};
export type UpdateGroupSiteRequestWeb = {
  siteId: number;
};
export type UpdateGroupRequestWeb = {
  groupId: number;
  name: string;
  levelId: number;
  parentId?: number | null;
  sites?: UpdateGroupSiteRequestWeb[] | null;
};
export type SaveCompanyLevelEntryRequestWeb = {
  levelId?: number | null;
  parentId?: number | null;
  name: string;
};
export type SaveCompanyLevelRequestWeb = {
  companyId: string;
  levels?: SaveCompanyLevelEntryRequestWeb[];
};
export type LevelIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Level[] | null;
};
export type PropertyValueWeb = {
  id: number;
  value: string | null;
  propertyName: string;
  propertyId: number;
  propertyType: PropertyType;
  createdDateTime: string;
  changedDateTime: string;
  changedById: string | null;
};
export type PatchPropertyValueRequestWeb = {
  value: string;
};
export type CreateCompanyPropertyRequestWeb = {
  companyId: string;
  propertyId: number;
  value: string;
};
export type PropertyWeb = {
  id: number;
  countryCode: string | null;
  propertyName: string;
  entityType: EntityType;
  propertyType: PropertyType;
  createdDateTime: string;
  changedDateTime: string;
  changedById: string | null;
};
export type PropertyTypeOptional = any;
export type EntityTypeOptional = any;
export type PatchPropertyRequestWeb = PartialUpdateRequestWeb & {
  countryCode?: StringOptional;
  propertyName?: StringOptional;
  propertyType?: PropertyTypeOptional;
  entityType?: EntityTypeOptional;
};
export type CreatePropertyRequestWeb = {
  propertyName: string;
  countryCode?: string | null;
  propertyType?: PropertyType;
  entityType?: EntityType;
};
export type CreateSitePropertyRequestWeb = {
  siteId: number;
  propertyId: number;
  value: string;
};
export type SiteBriefInfoDetailsWeb2023 = {
  longitude?: number | null;
  latitude?: number | null;
  type: string;
  code: string | null;
  license?: string | null;
  maxTotalBiomass?: number | null;
  timezone: string;
};
export type UnitBriefInfoWeb2023 = {
  unitId: number;
  unitName: string;
  longitude?: number | null;
  latitude?: number | null;
};
export type SiloBriefInfoWeb2023 = {
  siloId: number;
  siloName: string;
  capacity: number;
  contentOrder: string;
};
export type AdditionalPropertyValueWeb2023 = {
  id: number | null;
  value: string | null;
  propertyName: string | null;
  additionalDetailsPropertyId: number;
};
export type SiteBriefInfoWeb2023 = {
  siteId: number;
  siteName: string;
  info?: SiteBriefInfoDetailsWeb2023;
  units?: UnitBriefInfoWeb2023[] | null;
  silos?: SiloBriefInfoWeb2023[] | null;
  additionalPropertyValues?: AdditionalPropertyValueWeb2023[] | null;
};
export type CompanySiteBriefInfoWeb2023 = {
  companyId: string;
  licenseId: number | null;
  companyName: string;
  sites?: SiteBriefInfoWeb2023[] | null;
  additionalPropertyValues?: AdditionalPropertyValueWeb2023[] | null;
};
export type SiteBriefInfoDetailsWeb2025 = {
  longitude: number | null;
  latitude: number | null;
  type: string;
  code: string | null;
  license: string | null;
  maxTotalBiomass: number | null;
  timezone: string;
};
export type UnitBriefInfoWeb2025 = {
  unitId: number;
  unitName: string;
  longitude: number | null;
  latitude: number | null;
};
export type SiloBriefInfoWeb2025 = {
  siloId: number;
  siloName: string;
  capacity: number;
  contentOrder: string;
};
export type AdditionalPropertyValueWeb2025 = {
  id: number | null;
  value: string | null;
  propertyName: string | null;
  additionalDetailsPropertyId: number;
};
export type SiteBriefInfoWeb2025 = {
  siteId: number;
  siteName: string;
  info?: SiteBriefInfoDetailsWeb2025;
  units?: UnitBriefInfoWeb2025[] | null;
  silos?: SiloBriefInfoWeb2025[] | null;
  additionalPropertyValues?: AdditionalPropertyValueWeb2025[] | null;
};
export type CompanySiteBriefInfoWeb2025 = {
  companyId: string;
  companyName: string;
  sites?: SiteBriefInfoWeb2025[] | null;
  additionalPropertyValues?: AdditionalPropertyValueWeb2025[] | null;
};
export type SiloIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Silo[] | null;
};
export type Int64Optional = number;
export type PatchSiloRequestWeb = PartialUpdateRequestWeb & {
  siloName?: StringOptional;
  siloCode?: StringOptional;
  siteId?: Int32NullableOptional;
  bargeId?: Int32NullableOptional;
  capacity?: Int64Optional;
  deactivated?: BooleanOptional;
  deleted?: BooleanOptional;
  onShore?: BooleanOptional;
};
export type CreateSiloRequestWeb = {
  siloName: string;
  siteId?: number | null;
  contentOrder: SiloContentOrder;
  siloCode?: string | null;
  bargeId?: number | null;
  capacity?: number;
  onShore?: boolean;
};
export type SiteIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Site[] | null;
};
export type SiteIEnumerableODataValueRead = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: SiteRead[] | null;
};
export type SiteCompanyBriefInfoWeb = {
  siteId?: number;
  companyId: string;
  companyName: string;
  siteCode: string | null;
  siteName: string;
  siteType: string;
  license?: string | null;
  timezone: string;
  maxTotalBiomass?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  deActivatedInFarmer?: string | null;
  deActivedInFeedStation?: string | null;
  deletedInFarmer?: string | null;
  deletedInFeedStation?: string | null;
};
export type CreateSiteRequestWeb = {
  siteCode?: string | null;
  siteName: string;
  siteType: string;
  license?: string | null;
  companyId: string;
  timezone?: string | null;
  farmerCode?: string | null;
  maxTotalBiomass?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  groupId?: number | null;
  prefixIpAddress?: string | null;
};
export type SiteByCompanyWeb = {
  siteId: number;
  siteName: string;
  companyId: string;
  companyName: string;
  siteCode: string | null;
  siteType: string;
  latitude: number | null;
  longitude: number | null;
  license: string | null;
  maxTotalBiomass: number | null;
  groupId: number | null;
  timezone: string;
  unitCount: number;
  farmerCode: string | null;
  deleted: boolean;
  /** A datetime when the entity was last changed */
  changedDateTime: string;
};
export type SiteIncludeQueryWeb = "Units" | "Silos" | "AdditionalDetails";
export type UpdateSiteRequestWeb = {
  siteCode?: string | null;
  siteName: string;
  siteType: string;
  license?: string | null;
  companyId: string;
  timezone?: string | null;
  farmerCode?: string | null;
  maxTotalBiomass?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  deActivatedInFarmer?: string | null;
};
export type Int64NullableOptional = number | null;
export type DecimalNullableOptional = number | null;
export type DateTimeNullableOptional = string | null;
export type PatchSiteRequestWeb = PartialUpdateRequestWeb & {
  siteCode?: StringOptional;
  siteName?: StringOptional;
  siteType?: StringOptional;
  license?: StringOptional;
  companyId?: StringOptional;
  timezone?: StringOptional;
  associatedCompanyId?: StringOptional;
  farmerCode?: StringOptional;
  maxTotalBiomass?: Int64NullableOptional;
  longitude?: DecimalNullableOptional;
  latitude?: DecimalNullableOptional;
  deActivatedInFarmer?: DateTimeNullableOptional;
  deActivedInFeedStation?: DateTimeNullableOptional;
  deletedInFarmer?: DateTimeNullableOptional;
  deletedInFeedStation?: DateTimeNullableOptional;
  groupId?: Int32NullableOptional;
  deleted?: BooleanOptional;
  prefixIpAddress?: StringOptional;
};
export type BillableStatus = "NOT_BILLABLE" | "BILLABLE" | "UNPROCESSED";
export type InvoiceStatus =
  | "NOT_BILLABLE"
  | "PENDING"
  | "RUNNING"
  | "UNPROCESSED";
export type StationLicenseBillingGroupWeb = {
  applicationId: string;
  siteId: number;
  billableStatus?: BillableStatus;
  invoiceStatus: InvoiceStatus;
  billingScheduleNumber: string | null;
  note: string | null;
  lastUpdateTime: string;
  invoiceLastUpdatedByUserId: string | null;
  contractEnd?: string | null;
};
export type PutStationLicenseBillingGroupRequestWeb = {
  billableStatus: BillableStatus;
  invoiceStatus: InvoiceStatus;
  billingScheduleNumber: string | null;
  note: string | null;
  contractEnd?: string | null;
};
export type CategoryStationLicense = {
  categoryId: number;
  stationLicenseId: number;
  createdDateTime?: string | null;
  category?: Category;
  stationLicense?: StationLicense;
};
export type CategoryStationLicenseRead = {
  categoryId: number;
  stationLicenseId: number;
  createdDateTime?: string | null;
  category?: Category;
  stationLicense?: StationLicense;
};
export type Category = {
  id?: number;
  name: string;
  createdDateTime?: string;
  applicationCategories?: ApplicationCategory[];
  categoryStationLicenses?: CategoryStationLicense[];
};
export type CategoryRead = {
  id?: number;
  name: string;
  createdDateTime?: string;
  applicationCategories?: ApplicationCategory[];
  categoryStationLicenses?: CategoryStationLicenseRead[];
};
export type ApplicationCategory = {
  categoryId: number;
  category?: Category;
  applicationId: string;
  application?: Application;
};
export type ApplicationCategoryRead = {
  categoryId: number;
  category?: CategoryRead;
  applicationId: string;
  application?: Application;
};
export type Application = {
  applicationId: string;
  applicationName: string;
  applicationCategories?: ApplicationCategory[];
};
export type Author = {
  sub: string;
  email: string;
};
export type StationLicense = {
  stationLicenseId?: number;
  macAddress: string;
  hostName: string;
  expiryDate?: number;
  swVersion?: string | null;
  hdSerial: string;
  lastSeen?: number;
  createdDate?: number;
  lastUpdatedDate?: number;
  licenseType?: number;
  comment?: string | null;
  enabled?: boolean;
  siteId: number;
  site?: Site;
  applicationId: string;
  application?: Application;
  activationCode?: string | null;
  activated?: boolean;
  mode?: number;
  licenseKey?: string | null;
  createdBy?: Author;
  lastUpdatedBy?: Author;
  categoryStationLicenses?: CategoryStationLicense[];
};
export type StationLicenseRead = {
  stationLicenseId?: number;
  macAddress: string;
  hostName: string;
  expiryDate?: number;
  swVersion?: string | null;
  hdSerial: string;
  lastSeen?: number;
  createdDate?: number;
  lastUpdatedDate?: number;
  licenseType?: number;
  comment?: string | null;
  enabled?: boolean;
  siteId: number;
  site?: SiteRead;
  applicationId: string;
  application?: Application;
  activationCode?: string | null;
  activated?: boolean;
  mode?: number;
  licenseKey?: string | null;
  createdBy?: Author;
  lastUpdatedBy?: Author;
  categoryStationLicenses?: CategoryStationLicenseRead[];
};
export type StationLicenseIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: StationLicense[] | null;
};
export type StationLicenseIEnumerableODataValueRead = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: StationLicenseRead[] | null;
};
export type SiteAndProductStationLicenseGroupWeb = {
  stationLicenseIds: number[] | null;
  siteId: number | null;
  siteName: string | null;
  countryCode: string | null;
  companyId: string | null;
  companyName: string | null;
  applicationId: string | null;
  applicationName: string | null;
  softwareVersions: string | null;
  hdSerials: string | null;
  macAddresses: string | null;
  licenseKeys: string | null;
  activationCodes: string | null;
  licenseCount: number | null;
  activeCount: number | null;
  suspendedCount: number | null;
  expiredCount: number | null;
  lastSeen: number | null;
  minExpiryDate: string | null;
  maxExpiryDate: string | null;
  minCreatedDate: string | null;
  maxCreatedDate: string | null;
  createdDates: string[] | null;
  billableStatus: BillableStatus;
  invoiceStatus: InvoiceStatus;
  contractEndDateTime: string | null;
  billingGroupNote: string | null;
  billingGroupLastUpdateTime: string | null;
  billingScheduleNumber: string | null;
  categoryName: string | null;
};
export type SiteAndProductStationLicenseGroupWebIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: SiteAndProductStationLicenseGroupWeb[] | null;
};
export type CategoryWeb = {
  id: number;
  name: string;
};
export type StationLicensesGroupedByApplicationAndSwVersionWeb = {
  applicationId: string;
  applicationName: string;
  swVersions: string[];
  categories: CategoryWeb[];
};
export type StationLicensesGroupedByApplicationAndSwVersionWebIReadOnlyListODataValue =
  {
    /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
    "@odata.nextLink"?: string | null;
    /** Allows clients to get the total number of matching resources. */
    "@odata.count"?: number | null;
    /** A link containing metadata for the model of the matching resources. */
    "@odata.context"?: string | null;
    /** Gets or sets the OData response content in the "value". */
    value: StationLicensesGroupedByApplicationAndSwVersionWeb[] | null;
  };
export type UserRole = {
  id?: number;
  name?: string;
};
export type AccessArea = {
  areaName?: string;
  accessLevel?: string | null;
};
export type AccessGroup = {
  id?: number;
  companyGOSId?: string;
  accessGroupName?: string;
  accessGroupDescription?: string | null;
  accessAreas?: AccessArea[];
};
export type UnitAccess = {
  gosId?: number;
};
export type SiloAccess = {
  gosId?: number;
};
export type BargeAccess = {
  gosId?: number;
  silos?: SiloAccess[];
};
export type SiteAccess = {
  gosId?: number;
  accessGroups?: AccessGroup[];
  unitAccesses?: UnitAccess[];
  bargeAccesses?: BargeAccess[];
};
export type EntityGroupAccess = {
  groupName?: string;
  companyGosId?: string;
  levelName?: string;
  gosId?: number;
  parentGosId?: number | null;
  children?: EntityGroupAccess[];
  sites?: SiteAccess[];
  accessGroups?: AccessGroup[];
};
export type CompanyAccess = {
  gosId?: string;
  name?: string | null;
  suspended?: boolean;
  invitationPending?: boolean;
  accessGroups?: AccessGroup[];
  entityGroups?: EntityGroupAccess[];
  sites?: SiteAccess[];
};
export type CompanyAccessRead = {
  gosId?: string;
  name?: string | null;
  suspended?: boolean;
  invitationPending?: boolean;
  disabled?: boolean;
  accessGroups?: AccessGroup[];
  entityGroups?: EntityGroupAccess[];
  sites?: SiteAccess[];
};
export type UserAccess = {
  userId?: string;
  userIdType?: string;
  role?: UserRole;
  companyAccesses?: CompanyAccess[];
};
export type UserAccessRead = {
  userId?: string;
  userIdType?: string;
  role?: UserRole;
  companyAccesses?: CompanyAccessRead[];
};
export type StationLicenseAuthResponseWeb = {
  userAccess?: UserAccess;
  licenseId?: number | null;
};
export type StationLicenseAuthResponseWebRead = {
  userAccess?: UserAccessRead;
  licenseId?: number | null;
};
export type LicenseType =
  | "SEVEN_DAYS"
  | "ONE_MONTH"
  | "ONE_YEAR"
  | "THREE_YEARS"
  | "UNKNOWN";
export type LicenseServerAuthCodes =
  | "FOUND_HARDWARE_NO_CUSTOMER_NAME_IN_DATE"
  | "FOUND_HARDWARE_NO_CUSTOMER_NAME_EXPIRED"
  | "FOUND_HARDWARE_IN_DATE"
  | "FOUND_HARDWARE_ONE_YEAR_LICENSE_RENEWED"
  | "HARDWARE_NOT_FOUND_REGISTERED_TEMP_LICENSE"
  | "FOUND_HARDWARE_DISABLED"
  | "FOUND_HARDWARE_TEMP_LICENSE"
  | "FOUND_HARDWARE_RENEWED_IN_DATE"
  | "TEMPORARY_LICENSE_EXPIRED"
  | "CONVERTED_FROM_V1_TO_V2_ONE_YEAR_LICENSE"
  | "FOUND_HARDWARE_ONE_MONTH_LICENSE"
  | "FOUND_HARDWARE_ONE_MONTH_RENEWED"
  | "UNABLE_TO_DETERMINE_LICENSE_TYPE"
  | "TEMP_LICENSE_REJECTED"
  | "FOUND_HARDWARE_THREE_YEARS_LICENSE_RENEWED";
export type LicenseLegacyAuthResultWeb = {
  date?: number;
  companyName?: string | null;
  siteName?: string | null;
  message?: string | null;
  type?: LicenseType;
  code?: LicenseServerAuthCodes;
};
export type AuthorizeStationLicenseRequestWeb = {
  applicationName: string;
  hdSerial: string;
  macAddress?: string | null;
  hostName?: string | null;
  swVersion?: string | null;
};
export type UpdateStationLicenseRequestWeb = {
  stationLicenseId: number;
  licenseType: number;
  siteId: number;
  licenseKey?: string | null;
  comment?: string | null;
  expiryDate?: number;
  enabled?: boolean;
};
export type StatusStationLicenseRequestWeb = {
  applicationName: string;
  hdSerial: string;
  macAddress?: string | null;
};
export type ActivateStationLicenseRequestWeb = {
  activationCode: string;
  hdSerial?: string | null;
  version?: string | null;
  macAddress?: string | null;
  applicationName?: string | null;
};
export type CreateStationLicenseActivationCodeRequestWeb = {
  applicationId: string;
  siteId: number;
  comment?: string | null;
  hostName?: string | null;
  licenseType?: number;
  mode?: number;
};
export type CreatedActivationCodesWeb = {
  newLicenses: StationLicense[];
  licenseIds: number[];
};
export type CreatedActivationCodesWebRead = {
  newLicenses: StationLicenseRead[];
  licenseIds: number[];
};
export type CreatedLicenseKeyWeb = {
  key: string | null;
  data: StationLicense;
};
export type CreatedLicenseKeyWebRead = {
  key: string | null;
  data: StationLicenseRead;
};
export type CreateStationLicenseKeyRequestWeb = {
  hdSerial: string;
  applicationId: string;
  applicationName: string;
  macAddress?: string | null;
  hostName?: string | null;
  siteId: number;
  licenseType?: number;
  comment?: string | null;
};
export type CreatedLicenseKeysWeb = {
  newLicenses: StationLicense[];
  updatedLicenses: StationLicense[];
  failedLicenses: StationLicense[];
  licenseIds: number[];
};
export type CreatedLicenseKeysWebRead = {
  newLicenses: StationLicenseRead[];
  updatedLicenses: StationLicenseRead[];
  failedLicenses: StationLicenseRead[];
  licenseIds: number[];
};
export type UpdateStationLicenseVersionRequestWeb = {
  swVersion: string;
  comment?: string | null;
};
export type UpdateStationLicenseCategoryWeb = {
  categoryIds: number[];
};
export type UpdateTenantRequestWeb = {
  companyId: string;
  name: string;
};
export type TenantIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Tenant[] | null;
};
export type TenantODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  value: Tenant;
};
export type CreateUnitGroupRequestWeb = {
  siteId: number;
  name: string;
  color?: string | null;
  unitIds?: number[] | null;
};
export type UpdateUnitGroupRequestWeb = {
  unitGroupId?: number;
  siteId: number;
  name: string;
  color?: string | null;
};
export type UnitIEnumerableODataValue = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: Unit[] | null;
};
export type UnitIEnumerableODataValueRead = {
  /** Allows clients to fetch the next page of the previously fetched results until there are no more results left. */
  "@odata.nextLink"?: string | null;
  /** Allows clients to get the total number of matching resources. */
  "@odata.count"?: number | null;
  /** A link containing metadata for the model of the matching resources. */
  "@odata.context"?: string | null;
  /** Gets or sets the OData response content in the "value". */
  value: UnitRead[] | null;
};
export type CreateUnitRequestWeb = {
  unitName: string;
  unitCode?: string | null;
  unitModelId?: number | null;
  unitGroupId?: number | null;
  width?: number | null;
  depth?: number | null;
  volume?: number | null;
  seabed?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  unitShape?: UnitShape;
};
export type UpdateUnitRequestWeb = {
  unitName?: string;
  unitCode?: string | null;
  deactivated?: boolean;
  deActivatedInFarmer?: string | null;
  deletedInFarmer?: string | null;
};
export type UnitShapeNullableOptional = any;
export type PatchUnitRequestWeb = PartialUpdateRequestWeb & {
  unitName?: StringOptional;
  unitCode?: StringOptional;
  unitModelId?: Int32NullableOptional;
  unitGroupId?: Int32NullableOptional;
  width?: Int32NullableOptional;
  depth?: Int32NullableOptional;
  volume?: Int32NullableOptional;
  seabed?: Int32NullableOptional;
  longitude?: DecimalNullableOptional;
  latitude?: DecimalNullableOptional;
  deleted?: BooleanOptional;
  deactivated?: BooleanOptional;
  unitShape?: UnitShapeNullableOptional;
};
export type SaveUnitRequestWeb = {
  unitId?: number;
  unitName?: string;
  unitCode?: string | null;
  deActivatedInFarmer?: string | null;
  deletedInFarmer?: string | null;
};
export type UnitModelWeb = {
  id?: number;
  displayName: string;
  width?: number | null;
  depth?: number | null;
  volume?: number | null;
  unitShape?: UnitShape;
};
export type AuditType = "Created" | "Updated" | "Deleted";
export type AuditWeb = {
  auditId?: number;
  auditDate?: string;
  tableName: string;
  changedById: string;
  changedByType: string;
  auditType?: AuditType;
  keyValues?: {
    [key: string]: any;
  } | null;
  newValues?: {
    [key: string]: any;
  } | null;
  oldValues?: {
    [key: string]: any;
  } | null;
};
export type BriefUnitWeb = {
  id: number;
};
export type BriefSiloWeb = {
  id: number;
};
export type BriefBargeWeb = {
  id: number;
  silos?: BriefSiloWeb[];
};
export type BriefSiteWeb = {
  id: number;
  name: string;
  groupId: number | null;
  companyName: string;
  companyId: string;
  units: BriefUnitWeb[];
  barges: BriefBargeWeb[];
};
export const {
  useGetApiApplicationsQuery,
  usePostApiApplicationsMutation,
  useDeleteApiApplicationsMutation,
  useGetApiApplicationsIdQuery,
  usePutApiApplicationsIdMutation,
  useGetApiApplicationsIdVersionsQuery,
  usePutApiApplicationsIdVersionsMutation,
  usePostApiV1VersionsMutation,
  useGetApiV2BargeHistoriesQuery,
  useGetApiV2BargeHistoriesCountQuery,
  useGetApiV2BargeModelsQuery,
  useGetApiV2BargeModelsCountQuery,
  useGetApiV2BargesQuery,
  useGetApiV2BargesCountQuery,
  useGetApiV2BargesKeyQuery,
  usePostApiV2BargesMutation,
  usePutApiV2BargesKeyMutation,
  useGetApiV2BargesAvailableQuery,
  useGetApiV2CompaniesQuery,
  useGetApiV2CompaniesCountQuery,
  useGetApiV2CompaniesKeyQuery,
  useGetApiCompaniesQuery,
  usePostApiCompaniesMutation,
  useGetApiCompaniesEntitiesSimpleQuery,
  useGetApiCompaniesEntitiesAreaQuery,
  useGetApiCompaniesSitesQuery,
  useGetApiCompaniesIdQuery,
  usePutApiCompaniesIdMutation,
  usePatchApiCompaniesIdMutation,
  useDeleteApiCompaniesIdMutation,
  useGetApiCompaniesSelfQuery,
  useGetApiCompaniesCompanyIdHierarchyQuery,
  useGetApiCompaniesCompanyIdSmaQuery,
  useGetApiV2FeedCompaniesQuery,
  useGetApiV2FeedCompaniesCountQuery,
  useGetFeedsIdQuery,
  usePatchFeedsIdMutation,
  usePostFeedsMutation,
  useGetFeedsQuery,
  usePostFeedsIdDeleteMutation,
  usePostFeedsIdDeleteHardMutation,
  usePostFeedsIdUndeleteMutation,
  useGetApiCompaniesCompanyIdFeedsQuery,
  usePatchApiCompaniesCompanyIdFeedsFeedIdMutation,
  useDeleteApiFeedsIdMutation,
  useGetApiFeedsIdQuery,
  usePatchApiFeedsIdMutation,
  useGetApiFeedsQuery,
  usePostApiFeedsMutation,
  useGetApiFeedsBycompanyCompanyIdQuery,
  useGetApiV2FeedsGetAllForSiteSiteIdNullQuery,
  useGetFeedSuppliersIdQuery,
  usePatchFeedSuppliersIdMutation,
  usePostFeedSuppliersMutation,
  useGetFeedSuppliersQuery,
  usePostFeedSuppliersIdDeleteMutation,
  usePostFeedSuppliersIdDeleteHardMutation,
  usePostFeedSuppliersIdUndeleteMutation,
  useGetApiV2FeedSuppliersQuery,
  useGetApiV2FeedSuppliersCountQuery,
  usePostApiFeedSuppliersMutation,
  useGetApiFeedSuppliersQuery,
  usePatchApiFeedSuppliersIdMutation,
  useGetApiV2GroupsQuery,
  useGetApiV2GroupsCountQuery,
  useGetApiV2GroupsGetGroupsByCompanyCompanyIdCompanyIdQuery,
  useGetApiV2GroupsKeyQuery,
  useGetApiV2GroupsGetGroupsAndDescendantsQuery,
  usePostApiV2GroupsMutation,
  usePutApiV2GroupsKeyMutation,
  useDeleteApiV2GroupsKeyMutation,
  usePostApiV2LevelsPostTreeMutation,
  useGetApiV2LevelsQuery,
  useGetApiV2LevelsCountQuery,
  useGetApiV2LevelsGetAllForCompanyCompanyIdCompanyIdQuery,
  useGetApiV2LevelsKeyQuery,
  useGetCompanyPropertiesIdQuery,
  usePatchCompanyPropertiesIdMutation,
  useGetCompanyPropertiesQuery,
  usePostCompanyPropertiesMutation,
  usePostCompanyPropertiesIdDeleteHardMutation,
  useGetPropertiesIdQuery,
  usePatchPropertiesIdMutation,
  useGetPropertiesQuery,
  usePostPropertiesMutation,
  usePostPropertiesIdDeleteHardMutation,
  useGetSitePropertiesIdQuery,
  usePatchSitePropertiesIdMutation,
  useGetSitePropertiesQuery,
  usePostSitePropertiesMutation,
  usePostSitePropertiesIdDeleteHardMutation,
  useGetPublicMetaCompany20230101Query,
  useGetPublicMetaCompany20250101Query,
  useGetPublicMetaSitesId20230101Query,
  useGetPublicMetaSitesId20250101Query,
  useGetApiV2SilosQuery,
  useGetApiV2SilosCountQuery,
  useGetApiV2SilosKeyQuery,
  useGetApiSitesSiteIdSilosQuery,
  usePatchApiSilosIdMutation,
  useDeleteApiSilosIdMutation,
  usePostApiSilosMutation,
  useGetApiSitesSiteIdSilosAvailableQuery,
  useGetApiV2SitesQuery,
  useGetApiV2SitesCountQuery,
  useGetApiV2SitesKeyQuery,
  useGetApiSitesQuery,
  usePostApiSitesMutation,
  useGetApiCompaniesCompanyIdSitesQuery,
  useGetApiSitesIdQuery,
  usePutApiSitesIdMutation,
  usePatchApiSitesIdMutation,
  useDeleteApiSitesIdMutation,
  useGetApiSitesSelfIdQuery,
  useGetApiStationLicenseBillingGroupsSiteIdApplicationIdQuery,
  usePutApiStationLicenseBillingGroupsSiteIdApplicationIdMutation,
  useGetApiV2StationLicensesQuery,
  useGetApiV2StationLicensesCountQuery,
  useGetApiV2StationLicensesKeyQuery,
  useGetApiV2StationLicensesGetAllGroupedBySiteAndProductQuery,
  useGetApiV2StationLicensesGetAllGroupedByApplicationAndSwVersionQuery,
  useGetApiStationLicensesAuthQuery,
  usePostApiStationLicensesAuthMutation,
  useGetApiStationLicensesQuery,
  usePutApiStationLicensesMutation,
  useDeleteApiStationLicensesMutation,
  useGetApiStationLicensesCompanyCompanyIdQuery,
  useGetApiStationLicensesIdQuery,
  usePutApiStationLicensesIdMutation,
  usePostApiStationLicensesStatusMutation,
  usePostApiStationLicensesActivatelicenseMutation,
  usePostApiStationLicensesCreateactivationcodeMutation,
  usePostApiStationLicensesCreateactivationcodesMutation,
  usePostApiStationLicensesCreatelicensekeyMutation,
  usePostApiStationLicensesCreatelicensekeysMutation,
  usePutApiStationLicensesIdVersionMutation,
  usePutApiStationLicensesIdCategoriesMutation,
  usePostApiV2TenantsMutation,
  useGetApiV2TenantsQuery,
  useGetApiV2TenantsCountQuery,
  useGetApiV2TenantsKeyQuery,
  usePutApiV2TenantsKeyMutation,
  useDeleteApiV2TenantsKeyMutation,
  useGetApiSitesSiteIdUnitgroupsQuery,
  usePostApiSitesSiteIdUnitgroupsMutation,
  usePutApiSitesSiteIdUnitgroupsIdMutation,
  useDeleteApiSitesSiteIdUnitgroupsIdMutation,
  usePostApiSitesSiteIdUnitgroupsAllMutation,
  useGetApiV2UnitsQuery,
  useGetApiV2UnitsCountQuery,
  useGetApiV2UnitsKeyQuery,
  useGetApiSitesSiteIdUnitsQuery,
  usePostApiSitesSiteIdUnitsMutation,
  useGetApiSitesSiteIdUnitsUnitIdQuery,
  usePutApiSitesSiteIdUnitsUnitIdMutation,
  usePatchApiSitesSiteIdUnitsUnitIdMutation,
  usePostApiSitesSiteIdUnitsAllMutation,
  useDeleteApiSitesSiteIdUnitsIdMutation,
  useGetApiUnitsShapesQuery,
  useGetApiUnitsModelsQuery,
  useGetApiSitesSiteIdUnitsAvailableQuery,
  useGetApiSitesSiteIdUnitsUnitIdHistoryQuery,
  useGetApiUserAccessSitesQuery,
  useGetApiUserAccessSitesbygroupQuery,
} = injectedRtkApi;

import { gosApi } from "./gosApi";
export type gosApiType = typeof gosApi;
